var items = {
  "block.minecraft.acacia_button": "Акаассыйа кунуопка",
  "block.minecraft.acacia_door": "Акаассыйа аан",
  "block.minecraft.acacia_fence": "Акаассыйа күрүө",
  "block.minecraft.acacia_fence_gate": "Акаассыйа күрүө аана",
  "block.minecraft.acacia_hanging_sign": "Акаассыйа ыйанар бэлиэ",
  "block.minecraft.acacia_leaves": "Акаассыйа сэбирдэхтэрэ",
  "block.minecraft.acacia_log": "Акаассыйа бэрэбинэтэ",
  "block.minecraft.acacia_planks": "Акаассыйа хаптаһыннар",
  "block.minecraft.acacia_pressure_plate": "Акаассыйа тэпсиллэр билиитэтэ",
  "block.minecraft.acacia_sapling": "Акаассыйа талаҕа",
  "block.minecraft.acacia_shelf": "Акация долбуур",
  "block.minecraft.acacia_sign": "Акаассыйа бэлиэ",
  "block.minecraft.acacia_slab": "Акаассыйа билиитэтэ",
  "block.minecraft.acacia_stairs": "Акаассыйа үктэллэрэ",
  "block.minecraft.acacia_trapdoor": "Акаассыйа лүүк аан",
  "block.minecraft.acacia_wall_hanging_sign": "Акаассыйа истиэнэтээҕи бэлиэ",
  "block.minecraft.acacia_wall_sign": "Акаассыйа истиэнэтээҕи бэлиэ",
  "block.minecraft.acacia_wood": "Акаассыйа",
  "block.minecraft.activator_rail": "Холбонор тимир суол",
  "block.minecraft.air": "Салгын",
  "block.minecraft.allium": "Батун луук",
  "block.minecraft.amethyst_block": "Аметист булуога",
  "block.minecraft.amethyst_cluster": "Холбоспут аметистар",
  "block.minecraft.ancient_debris": "Былыргы үлтүркэй",
  "block.minecraft.andesite": "Андыһыыт",
  "block.minecraft.andesite_slab": "Андыһыыт билиитэтэ",
  "block.minecraft.andesite_stairs": "Андыһыыт үктэллэрэ",
  "block.minecraft.andesite_wall": "Андыһыыт күрүө",
  "block.minecraft.anvil": "Кыстык",
  "block.minecraft.attached_melon_stem": "Арбуус сыстыбыт умнаһа",
  "block.minecraft.attached_pumpkin_stem": "Тыыкыба сыстыбыт умнаһа",
  "block.minecraft.azalea": "Азалия",
  "block.minecraft.azalea_leaves": "Азалия сэбирдэхтэрэ",
  "block.minecraft.azure_bluet": "Бороҥ хаустония",
  "block.minecraft.bamboo": "Бамбук",
  "block.minecraft.bamboo_block": "Бамбук булуога",
  "block.minecraft.bamboo_button": "Бамбук кунуопка",
  "block.minecraft.bamboo_door": "Бамбук аан",
  "block.minecraft.bamboo_fence": "Бамбук күрүө",
  "block.minecraft.bamboo_fence_gate": "Бамбук күрүө аана",
  "block.minecraft.bamboo_hanging_sign": "Бамбук ыйанар бэлиэ",
  "block.minecraft.bamboo_mosaic": "Бамбук ойуута",
  "block.minecraft.bamboo_mosaic_slab": "Бамбук ойуулаах билиитэтэ",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбук ойуулаах үктэллэрэ",
  "block.minecraft.bamboo_planks": "Бамбук хаптаһыннар",
  "block.minecraft.bamboo_pressure_plate": "Бамбук тэпсиллэр билиитэтэ",
  "block.minecraft.bamboo_sapling": "Бамбук араскыта",
  "block.minecraft.bamboo_shelf": "Бамбук долбуур",
  "block.minecraft.bamboo_sign": "Бамбук бэлиэ",
  "block.minecraft.bamboo_slab": "Бамбук билиитэтэ",
  "block.minecraft.bamboo_stairs": "Бамбук үктэллэрэ",
  "block.minecraft.bamboo_trapdoor": "Бамбук лүүк аана",
  "block.minecraft.bamboo_wall_hanging_sign": "Бамбук истиэнэтээҕи бэлиэ",
  "block.minecraft.bamboo_wall_sign": "Бамбук истиэнэтээҕи бэлиэ",
  "block.minecraft.banner.base.black": "Хара хонуу",
  "block.minecraft.banner.base.blue": "Күөх хонуу",
  "block.minecraft.banner.base.brown": "Хара тураҕас хонуу",
  "block.minecraft.banner.base.cyan": "Бирюза хонуу",
  "block.minecraft.banner.base.gray": "Сур хонуу",
  "block.minecraft.banner.base.green": "От күөх хонуу",
  "block.minecraft.banner.base.light_blue": "Халлаан күөх хонуу",
  "block.minecraft.banner.base.light_gray": "Улаан хонуу",
  "block.minecraft.banner.base.lime": "Дьэҥкир күөх хонуу",
  "block.minecraft.banner.base.magenta": "Хара кыһыл хонуу",
  "block.minecraft.banner.base.orange": "Чачархай хонуу",
  "block.minecraft.banner.base.pink": "Оруосабай хонуу",
  "block.minecraft.banner.base.purple": "Хара саарыл хонуу",
  "block.minecraft.banner.base.red": "Кыһыл хонуу",
  "block.minecraft.banner.base.white": "Маҕан хонуу",
  "block.minecraft.banner.base.yellow": "Араҕас хонуу",
  "block.minecraft.banner.border.black": "Хара бүүрүк",
  "block.minecraft.banner.border.blue": "Күөх бүүрүк",
  "block.minecraft.banner.border.brown": "Күрэҥ бүүрүк",
  "block.minecraft.banner.border.cyan": "Бирюза бүүрүк",
  "block.minecraft.banner.border.gray": "Сур бүүрүк",
  "block.minecraft.banner.border.green": "От күөх бүүрүк",
  "block.minecraft.banner.border.light_blue": "Халлаан күөх бүүрүк",
  "block.minecraft.banner.border.light_gray": "Улаан бүүрүк",
  "block.minecraft.banner.border.lime": "Дьэҥкир күөх бүүрүк",
  "block.minecraft.banner.border.magenta": "Хараҥа кыһыл бүүрүк",
  "block.minecraft.banner.border.orange": "Чачархай бүүрүк",
  "block.minecraft.banner.border.pink": "Оруосабай бүүрүк",
  "block.minecraft.banner.border.purple": "Хара саарыл бүүрүк",
  "block.minecraft.banner.border.red": "Кыһыл бүүрүк",
  "block.minecraft.banner.border.white": "Маҥан бүүрүк",
  "block.minecraft.banner.border.yellow": "Араҕас бүүрүк",
  "block.minecraft.banner.bricks.black": "Хара муровка",
  "block.minecraft.banner.bricks.blue": "Күөх муровка",
  "block.minecraft.banner.bricks.brown": "Күрэҥ муровка",
  "block.minecraft.banner.bricks.cyan": "Бирюза муровка",
  "block.minecraft.banner.bricks.gray": "Сур муровка",
  "block.minecraft.banner.bricks.green": "От күөх муровка",
  "block.minecraft.banner.bricks.light_blue": "Халлаан күөх муровка",
  "block.minecraft.banner.bricks.light_gray": "Улаан муровка",
  "block.minecraft.banner.bricks.lime": "Дьэҥкир күөх муровка",
  "block.minecraft.banner.bricks.magenta": "Хараҥа кыһыл муровка",
  "block.minecraft.banner.bricks.orange": "Чачархай муровка",
  "block.minecraft.banner.bricks.pink": "Оруосабай муровка",
  "block.minecraft.banner.bricks.purple": "Хара саарыл муровка",
  "block.minecraft.banner.bricks.red": "Кыһыл муровка",
  "block.minecraft.banner.bricks.white": "Маҥан муровка",
  "block.minecraft.banner.bricks.yellow": "Араҕас муровка",
  "block.minecraft.banner.circle.black": "Хара төгүрүмтэ",
  "block.minecraft.banner.circle.blue": "Күөх төгүрүмтэ",
  "block.minecraft.banner.circle.brown": "Күрэҥ төгүрүмтэ",
  "block.minecraft.banner.circle.cyan": "Бирюза төгүрүмтэ",
  "block.minecraft.banner.circle.gray": "Сүр төгүрүмтэ",
  "block.minecraft.banner.circle.green": "От күөх төгүрүмтэ",
  "block.minecraft.banner.circle.light_blue": "Халлаан күөх төгүрүмтэ",
  "block.minecraft.banner.circle.light_gray": "Улаан төгүрүмтэ",
  "block.minecraft.banner.circle.lime": "Дьэҥкир күөх төгүрүмтэ",
  "block.minecraft.banner.circle.magenta": "Хараҥа кыһыл төгүрүмтэ",
  "block.minecraft.banner.circle.orange": "Чачархай төгүрүмтэ",
  "block.minecraft.banner.circle.pink": "Оруосабай төгүрүмтэ",
  "block.minecraft.banner.circle.purple": "Хара саарыл төгүрүмтэ",
  "block.minecraft.banner.circle.red": "Кыһыл төгүрүмтэ",
  "block.minecraft.banner.circle.white": "Маҥан төгүрүмтэ",
  "block.minecraft.banner.circle.yellow": "Араҕас төгүрүмтэ",
  "block.minecraft.banner.creeper.black": "Хара крипер",
  "block.minecraft.banner.creeper.blue": "Күөх крипер",
  "block.minecraft.banner.creeper.brown": "Күрэҥ крипер",
  "block.minecraft.banner.creeper.cyan": "Бирюза крипер",
  "block.minecraft.banner.creeper.gray": "Сур крипер",
  "block.minecraft.banner.creeper.green": "От күөх крипер",
  "block.minecraft.banner.creeper.light_blue": "Халлаан күөх крипер",
  "block.minecraft.banner.creeper.light_gray": "Улаан крипер",
  "block.minecraft.banner.creeper.lime": "Дьэҥкир күөх крипер",
  "block.minecraft.banner.creeper.magenta": "Хараҥа кыһыл крипер",
  "block.minecraft.banner.creeper.orange": "Чачархай крипер",
  "block.minecraft.banner.creeper.pink": "Оруосабай крипер",
  "block.minecraft.banner.creeper.purple": "Хара саарыл крипер",
  "block.minecraft.banner.creeper.red": "Кыһыл крипер",
  "block.minecraft.banner.creeper.white": "Маҥан крипер",
  "block.minecraft.banner.creeper.yellow": "Араҕас крипер",
  "block.minecraft.banner.cross.black": "Хара кириэс",
  "block.minecraft.banner.cross.blue": "Күөх кириэс",
  "block.minecraft.banner.cross.brown": "Күрэҥ кириэс",
  "block.minecraft.banner.cross.cyan": "Бирюза кириэс",
  "block.minecraft.banner.cross.gray": "Сур кириэс",
  "block.minecraft.banner.cross.green": "От күөх кириэс",
  "block.minecraft.banner.cross.light_blue": "Халлаан күөх кириэс",
  "block.minecraft.banner.cross.light_gray": "Улаан Андрей кириэс",
  "block.minecraft.banner.cross.lime": "Дьэҥкир күөх кириэс",
  "block.minecraft.banner.cross.magenta": "Хараҥа кыһыл кириэс",
  "block.minecraft.banner.cross.orange": "Чачархай кириэс",
  "block.minecraft.banner.cross.pink": "Оруосабай кириэс",
  "block.minecraft.banner.cross.purple": "Хара саарыл кириэс",
  "block.minecraft.banner.cross.red": "Кыһыл кириэс",
  "block.minecraft.banner.cross.white": "Маҥан кириэс",
  "block.minecraft.banner.cross.yellow": "Араҕас кириэс",
  "block.minecraft.banner.curly_border.black": "Хара ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.blue": "Күөх ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.brown": "Күрэҥ ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.cyan": "Бирюза ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.gray": "Сур ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.green": "От күөх ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.light_blue": "Халлаан күөх ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.light_gray": "Улаан ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.lime": "Сырдык от күөх ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.magenta": "Хараҥа кыһыл ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.orange": "Чачархай ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.pink": "Орусабай ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.purple": "Хара саарыл ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.red": "Кыһыл ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.white": "Маҥан ойуттаҕас бүүрүк",
  "block.minecraft.banner.curly_border.yellow": "Араҕас ойуттаҕас бүүрүк",
  "block.minecraft.banner.diagonal_left.black": "Хара хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.blue": "Күөх хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.brown": "Күрэҥ хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.cyan": "Бирюза хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.gray": "Сур хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.green": "От күөх хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.light_blue": "Халлаан күөх хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.light_gray": "Улаан хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.lime": "Дьэҥкир күөх хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.magenta": "Хараҥа кыһыл хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.orange": "Чачархай хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.pink": "Оруосабай хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.purple": "Хара саарыл хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.red": "Кыһыл хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.white": "Маҥан хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_left.yellow": "Араҕас хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.black": "Хара бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.blue": "Күөх бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.brown": "Күрэҥ бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.cyan": "Бирюза бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.gray": "Сур бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.green": "От күөх бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.light_blue": "Халлаан күөх бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.light_gray": "Улаан бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.lime": "Дьэҥкир күөх бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.magenta": "Хараҥа кыһыл бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.orange": "Чачархай бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.pink": "Оруосабай бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.purple": "Хара саарыл бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.red": "Кыһыл бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.white": "Маҥан бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_right.yellow": "Араҕас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_left.black": "Хара түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.blue": "Күөх түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.brown": "Күрэҥ түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.cyan": "Бирюза түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.gray": "Сур түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.green": "От күөх түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Халлаан күөх түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Улаан түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.lime": "Дьэҥкир күөх түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.magenta": "Хараҥа кыһыл түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.orange": "Чачархай түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.pink": "Оруосабай түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.purple": "Хара саарыл түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.red": "Кыһыл түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.white": "Маҥан түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_left.yellow": "Араҕас түнҥэриллибит бэрэбээскэ",
  "block.minecraft.banner.diagonal_up_right.black": "Хара түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.blue": "Күөх түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.brown": "Күрэҥ түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.cyan": "Бирюза түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.gray": "Сур түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.green": "От күөх түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Халлаан күөх түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Улаан түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.lime": "Дьэҥкир күөх түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.magenta": "Хараҥа кыһыл түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.orange": "Чачархай түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.pink": "Оруосабай түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.purple": "Хара саарыл түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.red": "Кыһыл түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.white": "Маҥан түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.diagonal_up_right.yellow": "Араҕас түнҥэриллибит хаҥас бэрэбээскэ быһыыта",
  "block.minecraft.banner.flow.black": "Хара сүүрүк",
  "block.minecraft.banner.flow.blue": "Күөх сүүрүк",
  "block.minecraft.banner.flow.brown": "Күрэҥ сүүрүк",
  "block.minecraft.banner.flow.cyan": "Бирюзовай сүүрүк",
  "block.minecraft.banner.flow.gray": "Сур сүүрүк",
  "block.minecraft.banner.flow.green": "От күөх сүүрүк",
  "block.minecraft.banner.flow.light_blue": "Халлаан күөх сүүрүк",
  "block.minecraft.banner.flow.light_gray": "Улаан сүүрүк",
  "block.minecraft.banner.flow.lime": "Дьэҥкир күөх сүүрүк",
  "block.minecraft.banner.flow.magenta": "Хараҥа кыһыл сүүрүк",
  "block.minecraft.banner.flow.orange": "Чачархай сүүрүк",
  "block.minecraft.banner.flow.pink": "Оруосабай сүүрүк",
  "block.minecraft.banner.flow.purple": "Хара саарыл сүүрүк",
  "block.minecraft.banner.flow.red": "Кыһыл сүүрүк",
  "block.minecraft.banner.flow.white": "Маҥан сүүрүк",
  "block.minecraft.banner.flow.yellow": "Саһархай сүүрүк",
  "block.minecraft.banner.flower.black": "Хара сибэкки",
  "block.minecraft.banner.flower.blue": "Күөх сибэкки",
  "block.minecraft.banner.flower.brown": "Күрэҥ сибэкки",
  "block.minecraft.banner.flower.cyan": "Бирюза сибэкки",
  "block.minecraft.banner.flower.gray": "Сур сибэкки",
  "block.minecraft.banner.flower.green": "От күөх сибэкки",
  "block.minecraft.banner.flower.light_blue": "Халлаан күөх сибэкки",
  "block.minecraft.banner.flower.light_gray": "Улаан сибэкки",
  "block.minecraft.banner.flower.lime": "Дьэҥкир күөх сибэкки",
  "block.minecraft.banner.flower.magenta": "Хараҥа кыһыл сэбикки",
  "block.minecraft.banner.flower.orange": "Чачархай сибэкки",
  "block.minecraft.banner.flower.pink": "Оруосабай сибэкки",
  "block.minecraft.banner.flower.purple": "Хара саарыл сибэкки",
  "block.minecraft.banner.flower.red": "Кыһыл сибэкки",
  "block.minecraft.banner.flower.white": "Маҥан сибэкки",
  "block.minecraft.banner.flower.yellow": "Араҕас сибэкки",
  "block.minecraft.banner.globe.black": "Хара глобус",
  "block.minecraft.banner.globe.blue": "Күөх глобус",
  "block.minecraft.banner.globe.brown": "Күрэҥ глобус",
  "block.minecraft.banner.globe.cyan": "Бирюза глобус",
  "block.minecraft.banner.globe.gray": "Сур глобус",
  "block.minecraft.banner.globe.green": "От күөх глобус",
  "block.minecraft.banner.globe.light_blue": "Халлаан күөх глобус",
  "block.minecraft.banner.globe.light_gray": "Улаан глобус",
  "block.minecraft.banner.globe.lime": "Дьэҥкир күөх глобус",
  "block.minecraft.banner.globe.magenta": "Хараҥа кыһыл глобус",
  "block.minecraft.banner.globe.orange": "Чачархай глобус",
  "block.minecraft.banner.globe.pink": "Оруосабай глобус",
  "block.minecraft.banner.globe.purple": "Хара саарыл глобус",
  "block.minecraft.banner.globe.red": "Кыһыл глобус",
  "block.minecraft.banner.globe.white": "Маҥан глобус",
  "block.minecraft.banner.globe.yellow": "Араҕас глобус",
  "block.minecraft.banner.gradient.black": "Хара градиент",
  "block.minecraft.banner.gradient.blue": "Күөх градиент",
  "block.minecraft.banner.gradient.brown": "Күрэҥ градиент",
  "block.minecraft.banner.gradient.cyan": "Бирюза градиент",
  "block.minecraft.banner.gradient.gray": "Сур градиент",
  "block.minecraft.banner.gradient.green": "От күөх градиент",
  "block.minecraft.banner.gradient.light_blue": "Халлаан күөх градиент",
  "block.minecraft.banner.gradient.light_gray": "Улахан градиет",
  "block.minecraft.banner.gradient.lime": "Дьэҥкир күөх градиент",
  "block.minecraft.banner.gradient.magenta": "Хараҥа кыһыл градиент",
  "block.minecraft.banner.gradient.orange": "Чачархай градиент",
  "block.minecraft.banner.gradient.pink": "Оруосабай градиент",
  "block.minecraft.banner.gradient.purple": "Хара саарыл градиент",
  "block.minecraft.banner.gradient.red": "Кыһыл градиент",
  "block.minecraft.banner.gradient.white": "Маҥан градиент",
  "block.minecraft.banner.gradient.yellow": "Араҕас градиент",
  "block.minecraft.banner.gradient_up.black": "Хара төттөрү градиент",
  "block.minecraft.banner.gradient_up.blue": "Күөх төттөрү градиент",
  "block.minecraft.banner.gradient_up.brown": "Күрэҥ төттөрү градиент",
  "block.minecraft.banner.gradient_up.cyan": "Бирюза төттөрү градиент",
  "block.minecraft.banner.gradient_up.gray": "Сүр төттөрү градиент",
  "block.minecraft.banner.gradient_up.green": "От күөх төттөрү градиент",
  "block.minecraft.banner.gradient_up.light_blue": "Халлаан күөх төттөрү градиент",
  "block.minecraft.banner.gradient_up.light_gray": "Улаан төттөрү градиент",
  "block.minecraft.banner.gradient_up.lime": "Дьэҥкир күөх төттөрү градиент",
  "block.minecraft.banner.gradient_up.magenta": "Хараҥа кыһыл төттөрү градиент",
  "block.minecraft.banner.gradient_up.orange": "Чачархай төттөрү градиент",
  "block.minecraft.banner.gradient_up.pink": "Оруосабай төттөрү градиент",
  "block.minecraft.banner.gradient_up.purple": "Хара саарыл төттөрү градиент",
  "block.minecraft.banner.gradient_up.red": "Кыһыл төттөрү градиент",
  "block.minecraft.banner.gradient_up.white": "Маҥан төттөрү градиент",
  "block.minecraft.banner.gradient_up.yellow": "Араҕас төттөрү градиент",
  "block.minecraft.banner.guster.black": "Хара холорук",
  "block.minecraft.banner.guster.blue": "Хараҥа халлаан күөх холорук",
  "block.minecraft.banner.guster.brown": "Күрэҥ холорук",
  "block.minecraft.banner.guster.cyan": "Бирюзовай холорук",
  "block.minecraft.banner.guster.gray": "Сиэрэй холорук",
  "block.minecraft.banner.guster.green": "От күөх холорук",
  "block.minecraft.banner.guster.light_blue": "Халлаан куөх холорук",
  "block.minecraft.banner.guster.light_gray": "Сырдыктыы-сиэрэй холорук",
  "block.minecraft.banner.guster.lime": "Дьэҥкир күөх холорук",
  "block.minecraft.banner.guster.magenta": "Хараҥа кыһыл холорук",
  "block.minecraft.banner.guster.orange": "Чачархай холорук",
  "block.minecraft.banner.guster.pink": "Оруосабай холорук",
  "block.minecraft.banner.guster.purple": "Хара саарыл холорук",
  "block.minecraft.banner.guster.red": "Кыһыл холорук",
  "block.minecraft.banner.guster.white": "Маҥан холорук",
  "block.minecraft.banner.guster.yellow": "Саһархай холорук",
  "block.minecraft.banner.half_horizontal.black": "Хара үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.blue": "Күөх үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.brown": "Күрэҥ үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.cyan": "Бирюза үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.gray": "Сур үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.green": "От күөх үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.light_blue": "Халлаан күөх үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.light_gray": "Улаан үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.lime": "Дьэҥкир күөх үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.magenta": "Хараҥа кыһыл үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.orange": "Чачархай үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.pink": "Оруосабай үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.purple": "Хара саарыл үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.red": "Кыһыл үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.white": "Маҥан үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal.yellow": "Араҕас үөһээҥи аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.black": "Хара алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Күөх алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Күрэҥ алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Бирюза алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Сур алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.green": "От күөх алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Халлаан күөх алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Улаан алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Дьэҥкир күөх алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Хараҥа кыһыл алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Чачархай алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Оруосабай алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Хара саарыл алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.red": "Кыһыл алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.white": "Маҥан алларааҥы аҥаара",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Араҕас алларааҥы аҥаара",
  "block.minecraft.banner.half_vertical.black": "Хара уҥа аҥара",
  "block.minecraft.banner.half_vertical.blue": "Күөх уҥа аҥара",
  "block.minecraft.banner.half_vertical.brown": "Күрэҥ уҥа аҥара",
  "block.minecraft.banner.half_vertical.cyan": "Бирюза уҥа аҥара",
  "block.minecraft.banner.half_vertical.gray": "Сур уҥа аҥара",
  "block.minecraft.banner.half_vertical.green": "От күөх уҥа аҥара",
  "block.minecraft.banner.half_vertical.light_blue": "Халлаан күөх уҥа аҥара",
  "block.minecraft.banner.half_vertical.light_gray": "Улаан уҥа аҥара",
  "block.minecraft.banner.half_vertical.lime": "Дьэҥкир күөх уҥа аҥара",
  "block.minecraft.banner.half_vertical.magenta": "Хараҥа кыһыл уҥа аҥара",
  "block.minecraft.banner.half_vertical.orange": "Чачархай уҥа аҥара",
  "block.minecraft.banner.half_vertical.pink": "Оруосабай уҥа аҥара",
  "block.minecraft.banner.half_vertical.purple": "Хара саарыл уҥа аҥара",
  "block.minecraft.banner.half_vertical.red": "Кыһыл уҥа аҥара",
  "block.minecraft.banner.half_vertical.white": "Маҥан уҥа аҥар",
  "block.minecraft.banner.half_vertical.yellow": "Араҕас уҥа аҥара",
  "block.minecraft.banner.half_vertical_right.black": "Хара дьэгин",
  "block.minecraft.banner.half_vertical_right.blue": "Күөх дьэгин",
  "block.minecraft.banner.half_vertical_right.brown": "Күрэҥ дьэгин",
  "block.minecraft.banner.half_vertical_right.cyan": "Бирюза дьэгин",
  "block.minecraft.banner.half_vertical_right.gray": "Сур дьэгин",
  "block.minecraft.banner.half_vertical_right.green": "От күөх дьэгин",
  "block.minecraft.banner.half_vertical_right.light_blue": "Халлаан күөх дьэгин",
  "block.minecraft.banner.half_vertical_right.light_gray": "Улаан дьэгин",
  "block.minecraft.banner.half_vertical_right.lime": "Дьэҥкир күөх дьэгин",
  "block.minecraft.banner.half_vertical_right.magenta": "Хараҥа кыһыл дьэгин",
  "block.minecraft.banner.half_vertical_right.orange": "Чачархай дьэгин",
  "block.minecraft.banner.half_vertical_right.pink": "Оруосабай дьэгин",
  "block.minecraft.banner.half_vertical_right.purple": "Хара саарыл дьэгин",
  "block.minecraft.banner.half_vertical_right.red": "Кыһыл дьэгин",
  "block.minecraft.banner.half_vertical_right.white": "Маҥан дьэгин",
  "block.minecraft.banner.half_vertical_right.yellow": "Араҕас дьэгин",
  "block.minecraft.banner.mojang.black": "Хара туох эрэ",
  "block.minecraft.banner.mojang.blue": "Күөх туох эрэ",
  "block.minecraft.banner.mojang.brown": "Күрэҥ туох эмэ",
  "block.minecraft.banner.mojang.cyan": "Бирюза туох эрэ",
  "block.minecraft.banner.mojang.gray": "Сур туох эрэ",
  "block.minecraft.banner.mojang.green": "От күөх туох эрэ",
  "block.minecraft.banner.mojang.light_blue": "Халлаан күөх туох эрэ",
  "block.minecraft.banner.mojang.light_gray": "Улаан туох эрэ",
  "block.minecraft.banner.mojang.lime": "Дьэҥкир күөх туох эрэ",
  "block.minecraft.banner.mojang.magenta": "Хараҥа кыһыл туох эрэ",
  "block.minecraft.banner.mojang.orange": "Чачархай туох эрэ",
  "block.minecraft.banner.mojang.pink": "Оруосабай туох эрэ",
  "block.minecraft.banner.mojang.purple": "Хара саарыл туох эрэ",
  "block.minecraft.banner.mojang.red": "Кыһыл туох эрэ",
  "block.minecraft.banner.mojang.white": "Маҥан туох эрэ",
  "block.minecraft.banner.mojang.yellow": "Араҕас туох эрэ",
  "block.minecraft.banner.piglin.black": "Хара тумус",
  "block.minecraft.banner.piglin.blue": "Күөх тумус",
  "block.minecraft.banner.piglin.brown": "Күрэҥ тумус",
  "block.minecraft.banner.piglin.cyan": "Бирюза тумус",
  "block.minecraft.banner.piglin.gray": "Сур тумус",
  "block.minecraft.banner.piglin.green": "От күөх тумус",
  "block.minecraft.banner.piglin.light_blue": "Сырдык күөх тумус",
  "block.minecraft.banner.piglin.light_gray": "Улаан тумус",
  "block.minecraft.banner.piglin.lime": "Сырдык от күөх тумус",
  "block.minecraft.banner.piglin.magenta": "Хараҥа кыһыл тумус",
  "block.minecraft.banner.piglin.orange": "Чачархай тумус",
  "block.minecraft.banner.piglin.pink": "Оруосабай тумус",
  "block.minecraft.banner.piglin.purple": "Хара саарыл тумус",
  "block.minecraft.banner.piglin.red": "Кыһыл тумус",
  "block.minecraft.banner.piglin.white": "Маҥан тумус",
  "block.minecraft.banner.piglin.yellow": "Араҕас тумус",
  "block.minecraft.banner.rhombus.black": "Хара ромб",
  "block.minecraft.banner.rhombus.blue": "Күөх ромб",
  "block.minecraft.banner.rhombus.brown": "Күрэҥ ромб",
  "block.minecraft.banner.rhombus.cyan": "Бирюза ромб",
  "block.minecraft.banner.rhombus.gray": "Сур ромб",
  "block.minecraft.banner.rhombus.green": "От күөх ромб",
  "block.minecraft.banner.rhombus.light_blue": "Халлаан күөх ромб",
  "block.minecraft.banner.rhombus.light_gray": "Улаан ромб",
  "block.minecraft.banner.rhombus.lime": "Дьэҥкир күөх ромб",
  "block.minecraft.banner.rhombus.magenta": "Хараҥа кыһыл ромб",
  "block.minecraft.banner.rhombus.orange": "Чачархай ромб",
  "block.minecraft.banner.rhombus.pink": "Оруосабай ромб",
  "block.minecraft.banner.rhombus.purple": "Хара саарыл ромб",
  "block.minecraft.banner.rhombus.red": "Кыһыл ромб",
  "block.minecraft.banner.rhombus.white": "Маҥан ромб",
  "block.minecraft.banner.rhombus.yellow": "Араҕас ромб",
  "block.minecraft.banner.skull.black": "Хара бас уҥуоҕа",
  "block.minecraft.banner.skull.blue": "Күөх бас уҥуоҕа",
  "block.minecraft.banner.skull.brown": "Күрэҥ бас уҥуоҕа",
  "block.minecraft.banner.skull.cyan": "Бирюза бас уҥуоҕа",
  "block.minecraft.banner.skull.gray": "Сур бас уҥуоҕа",
  "block.minecraft.banner.skull.green": "От күөх бас уҥуоҕа",
  "block.minecraft.banner.skull.light_blue": "Халлаан күөх бас уҥуоҕа",
  "block.minecraft.banner.skull.light_gray": "Улаан бас уҥуоҕа",
  "block.minecraft.banner.skull.lime": "Дьэҥкир күөх бас уҥуоҕа",
  "block.minecraft.banner.skull.magenta": "Хараҥа кыһыл бас уҥуоҕа",
  "block.minecraft.banner.skull.orange": "Чачархай бас уҥуоҕа",
  "block.minecraft.banner.skull.pink": "Оруосабай бас уҥуоҕа",
  "block.minecraft.banner.skull.purple": "Хара саарыл бас уҥуоҕа",
  "block.minecraft.banner.skull.red": "Кыһыл бас уҥуоҕа",
  "block.minecraft.banner.skull.white": "Маҥан бас уҥуоҕа",
  "block.minecraft.banner.skull.yellow": "Араҕас бас уҥуоҕа",
  "block.minecraft.banner.small_stripes.black": "Хара остуолбалар",
  "block.minecraft.banner.small_stripes.blue": "Күөх остуолбалар",
  "block.minecraft.banner.small_stripes.brown": "Күрэҥ остуолбалар",
  "block.minecraft.banner.small_stripes.cyan": "Бирюза остуолбалар",
  "block.minecraft.banner.small_stripes.gray": "Сур остуолбалар",
  "block.minecraft.banner.small_stripes.green": "От күөх остуолбалар",
  "block.minecraft.banner.small_stripes.light_blue": "Халлаан күөх остуолбалар",
  "block.minecraft.banner.small_stripes.light_gray": "Улаан остуолбалар",
  "block.minecraft.banner.small_stripes.lime": "Дьэҥкир күөх остуолбалар",
  "block.minecraft.banner.small_stripes.magenta": "Хараҥа кыһыл остуолбалар",
  "block.minecraft.banner.small_stripes.orange": "Чачархай остуолбалар",
  "block.minecraft.banner.small_stripes.pink": "Оруосабай остуолбалар",
  "block.minecraft.banner.small_stripes.purple": "Хара саарыл остуолбалар",
  "block.minecraft.banner.small_stripes.red": "Кыһыл остуолбалар",
  "block.minecraft.banner.small_stripes.white": "Маҥан остуолбалар",
  "block.minecraft.banner.small_stripes.yellow": "Араҕас остуолбалар",
  "block.minecraft.banner.square_bottom_left.black": "Хара алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.blue": "Күөх алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.brown": "Күрэҥ алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.cyan": "Бирюза алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.gray": "Сур алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.green": "От күөх алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.light_blue": "Халлаан күөх алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.light_gray": "Улаан алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.lime": "Дьэҥкир күөх алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.magenta": "Хараҥа кыһыл алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.orange": "Чачархай алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.pink": "Оруосабай алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.purple": "Хара алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.red": "Кыһыл алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.white": "Маҥан алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_left.yellow": "Араҕас алларааҥы уҥа муннук",
  "block.minecraft.banner.square_bottom_right.black": "Хара алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.blue": "Күөх алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.brown": "Күрэҥ алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.cyan": "Бирюза алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.gray": "Сур алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.green": "От күөх алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.light_blue": "Халлаан күөх алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.light_gray": "Улаан алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.lime": "Дьэҥкир күөх алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.magenta": "Хараҥа кыһыл алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.orange": "Чачархай алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.pink": "Оруосабай алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.purple": "Хара саарыл алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.red": "Кыһыл алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.white": "Маҥан алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_bottom_right.yellow": "Араҕас алларааҥы хаҥас муннук",
  "block.minecraft.banner.square_top_left.black": "Хара үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.blue": "Күөх үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.brown": "Күрэҥ үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.cyan": "Бирюза үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.gray": "Сур үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.green": "От күөх үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.light_blue": "Халлаан күөх үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.light_gray": "Улаан үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.lime": "Дьэҥкир күөх үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.magenta": "Хараҥа кыһыл үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.orange": "Чачархай үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.pink": "Оруосабай үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.purple": "Хара саарыл үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.red": "Кыһыл үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.white": "Маҥан үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_left.yellow": "Араҕас үөһээҥи уҥа муннук",
  "block.minecraft.banner.square_top_right.black": "Хара үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.blue": "Күөх үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.brown": "Күрэҥ үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.cyan": "Бирюза үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.gray": "Сур үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.green": "От күөх үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.light_blue": "Халлаан күөх үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.light_gray": "Улаан үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.lime": "Дьэҥкир күөх үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.magenta": "Хараҥа кыһыл үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.orange": "Чачархай үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.pink": "Оруосабай үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.purple": "Хара саарыл үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.red": "Кыһыл үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.white": "Маҥан үөһээҥи хаҥас муннук",
  "block.minecraft.banner.square_top_right.yellow": "Араҕас үөһээҥи хаҥас муннук",
  "block.minecraft.banner.straight_cross.black": "Хара Кириэс",
  "block.minecraft.banner.straight_cross.blue": "Күөх кириэс",
  "block.minecraft.banner.straight_cross.brown": "Күрэҥ кириэс",
  "block.minecraft.banner.straight_cross.cyan": "Бирюза кириэс",
  "block.minecraft.banner.straight_cross.gray": "Сур кириэс",
  "block.minecraft.banner.straight_cross.green": "От күөх кириэс",
  "block.minecraft.banner.straight_cross.light_blue": "Халлаан күөх кириэс",
  "block.minecraft.banner.straight_cross.light_gray": "Улаан кириэс",
  "block.minecraft.banner.straight_cross.lime": "Дьэҥкир күөх кириэс",
  "block.minecraft.banner.straight_cross.magenta": "Хараҥа кыһыл кириэс",
  "block.minecraft.banner.straight_cross.orange": "Чачархай кириэс",
  "block.minecraft.banner.straight_cross.pink": "Оруосабай кириэс",
  "block.minecraft.banner.straight_cross.purple": "Хара саарыл кириэс",
  "block.minecraft.banner.straight_cross.red": "Кыһыл кириэс",
  "block.minecraft.banner.straight_cross.white": "Маҥан кириэс",
  "block.minecraft.banner.straight_cross.yellow": "Араҕас кириэс",
  "block.minecraft.banner.stripe_bottom.black": "Хара төрүт",
  "block.minecraft.banner.stripe_bottom.blue": "Күөх төрүт",
  "block.minecraft.banner.stripe_bottom.brown": "Күрэҥ төрүт",
  "block.minecraft.banner.stripe_bottom.cyan": "Бирюза төрүт",
  "block.minecraft.banner.stripe_bottom.gray": "Сур төрүт",
  "block.minecraft.banner.stripe_bottom.green": "От күөх төрүт",
  "block.minecraft.banner.stripe_bottom.light_blue": "Халлаан күөх төрүт",
  "block.minecraft.banner.stripe_bottom.light_gray": "Улаан төрүт",
  "block.minecraft.banner.stripe_bottom.lime": "Дьэҥкир күөх төрүт",
  "block.minecraft.banner.stripe_bottom.magenta": "Хараҥа кыһыл төрүт",
  "block.minecraft.banner.stripe_bottom.orange": "Чачархай төрүт",
  "block.minecraft.banner.stripe_bottom.pink": "Оруосабай төрүт",
  "block.minecraft.banner.stripe_bottom.purple": "Хара саарыл төрүт",
  "block.minecraft.banner.stripe_bottom.red": "Кыһыл төрүт",
  "block.minecraft.banner.stripe_bottom.white": "Маҥан төрүт",
  "block.minecraft.banner.stripe_bottom.yellow": "Араҕас төрүт",
  "block.minecraft.banner.stripe_center.black": "Хара остуолба",
  "block.minecraft.banner.stripe_center.blue": "Күөх остуолба",
  "block.minecraft.banner.stripe_center.brown": "Күрэҥ остуолба",
  "block.minecraft.banner.stripe_center.cyan": "Бирюза остуолба",
  "block.minecraft.banner.stripe_center.gray": "Сур остуолба",
  "block.minecraft.banner.stripe_center.green": "От күөх остуолба",
  "block.minecraft.banner.stripe_center.light_blue": "Халлаан күөх остуолба",
  "block.minecraft.banner.stripe_center.light_gray": "Улаан остуолба",
  "block.minecraft.banner.stripe_center.lime": "Дьэҥкир күөх остуолба",
  "block.minecraft.banner.stripe_center.magenta": "Хараҥа кыһыл остуолба",
  "block.minecraft.banner.stripe_center.orange": "Чачархай остуолба",
  "block.minecraft.banner.stripe_center.pink": "Оруосабай остуолба",
  "block.minecraft.banner.stripe_center.purple": "Хара саарыл остуолба",
  "block.minecraft.banner.stripe_center.red": "Кыһыл остуолба",
  "block.minecraft.banner.stripe_center.white": "Маҥан остуолба",
  "block.minecraft.banner.stripe_center.yellow": "Араҕас остуолба",
  "block.minecraft.banner.stripe_downleft.black": "Хара дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.blue": "Күөх дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.brown": "Күрэҥ дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.cyan": "Бирюза дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.gray": "Сур дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.green": "От күөх дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.light_blue": "Халлаан күөх дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.light_gray": "Улаан дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.lime": "Дьэҥкир күөх дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.magenta": "Хараҥа кыһыл дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.orange": "Чачархай дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.pink": "Оруосабай дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.purple": "Хара саарыл дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.red": "Кыһыл дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.white": "Маҥан дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downleft.yellow": "Араҕас дьэгин бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.black": "Хара бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.blue": "Күөх бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.brown": "Күрэҥ бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.cyan": "Бирюза бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.gray": "Сур бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.green": "От күөх бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.light_blue": "Халлаан күөх бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.light_gray": "Улаан бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.lime": "Дьэҥкир күөх бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.magenta": "Хараҥа кыһыл бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.orange": "Чачархай бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.pink": "Оруосабай бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.purple": "Хара саарыл бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.red": "Кыһыл бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.white": "Маҥан бэрэбээскэ",
  "block.minecraft.banner.stripe_downright.yellow": "Араҕас бэрэбээскэ",
  "block.minecraft.banner.stripe_left.black": "Хара бороҕон остуолба",
  "block.minecraft.banner.stripe_left.blue": "Күөх бороҕон остуолба",
  "block.minecraft.banner.stripe_left.brown": "Күрэҥ бороҕон остуолба",
  "block.minecraft.banner.stripe_left.cyan": "Бирюза бороҕон остуолба",
  "block.minecraft.banner.stripe_left.gray": "Сур бороҕон остуолба",
  "block.minecraft.banner.stripe_left.green": "От күөх бороҕон остуолба",
  "block.minecraft.banner.stripe_left.light_blue": "Халлаан күөх бороҕон остуолба",
  "block.minecraft.banner.stripe_left.light_gray": "Улаан бороҕон остуолба",
  "block.minecraft.banner.stripe_left.lime": "Дьэҥкир күөх бороҕон остулба",
  "block.minecraft.banner.stripe_left.magenta": "Хараҥа кыһыл бороҕон остуолба",
  "block.minecraft.banner.stripe_left.orange": "Чачархай бороҕон остуолба",
  "block.minecraft.banner.stripe_left.pink": "Оруосабай бороҕон остуолба",
  "block.minecraft.banner.stripe_left.purple": "Хара саарыл бороҕон остуолба",
  "block.minecraft.banner.stripe_left.red": "Кыһыл бороҕон остуолба",
  "block.minecraft.banner.stripe_left.white": "Маҥан бороҕон остуолба",
  "block.minecraft.banner.stripe_left.yellow": "Араҕас бороҕон остуолба",
  "block.minecraft.banner.stripe_middle.black": "Хара кур",
  "block.minecraft.banner.stripe_middle.blue": "Күөх кур",
  "block.minecraft.banner.stripe_middle.brown": "Күрэҥ кур",
  "block.minecraft.banner.stripe_middle.cyan": "Бирюза кур",
  "block.minecraft.banner.stripe_middle.gray": "Сур кур",
  "block.minecraft.banner.stripe_middle.green": "От күөх кур",
  "block.minecraft.banner.stripe_middle.light_blue": "Халлаан күөх кур",
  "block.minecraft.banner.stripe_middle.light_gray": "Улаан кур",
  "block.minecraft.banner.stripe_middle.lime": "Дьэҥкир күөх кур",
  "block.minecraft.banner.stripe_middle.magenta": "Хараҥа кыһыл кур",
  "block.minecraft.banner.stripe_middle.orange": "Чачархай кур",
  "block.minecraft.banner.stripe_middle.pink": "Оруосабай кур",
  "block.minecraft.banner.stripe_middle.purple": "Хара саарыл кур",
  "block.minecraft.banner.stripe_middle.red": "Кыһыл кур",
  "block.minecraft.banner.stripe_middle.white": "Маҥан кур",
  "block.minecraft.banner.stripe_middle.yellow": "Араҕас кур",
  "block.minecraft.banner.stripe_right.black": "Хара дьэгин остуолба",
  "block.minecraft.banner.stripe_right.blue": "Күөх дьэгин остуолба",
  "block.minecraft.banner.stripe_right.brown": "Күрэҥ дьэгин остуолба",
  "block.minecraft.banner.stripe_right.cyan": "Бирюза дьэгин остуолба",
  "block.minecraft.banner.stripe_right.gray": "Сур дьэгин остуолба",
  "block.minecraft.banner.stripe_right.green": "От күөх дьэгин остуолба",
  "block.minecraft.banner.stripe_right.light_blue": "Халлаан күөх дьэгин остуолба",
  "block.minecraft.banner.stripe_right.light_gray": "Улаан дьэгин остуолба",
  "block.minecraft.banner.stripe_right.lime": "Дьэҥкир күөх дьэгин остуолба",
  "block.minecraft.banner.stripe_right.magenta": "Хараҥа кыһыл дьэгин остуолба",
  "block.minecraft.banner.stripe_right.orange": "Чачархай дьэгин остуолба",
  "block.minecraft.banner.stripe_right.pink": "Оруосабай дьэгин остуолба",
  "block.minecraft.banner.stripe_right.purple": "Хара саарыл дьэгин остуолба",
  "block.minecraft.banner.stripe_right.red": "Кыһыл дьэгин остуолба",
  "block.minecraft.banner.stripe_right.white": "Маҥан дьэгин остуолба",
  "block.minecraft.banner.stripe_right.yellow": "Араҕас дьэгин остуолба",
  "block.minecraft.banner.stripe_top.black": "Хара төбө",
  "block.minecraft.banner.stripe_top.blue": "Күөх төбө",
  "block.minecraft.banner.stripe_top.brown": "Күрэҥ төбө",
  "block.minecraft.banner.stripe_top.cyan": "Бирюза төбө",
  "block.minecraft.banner.stripe_top.gray": "Сур төбө",
  "block.minecraft.banner.stripe_top.green": "От күөх төбө",
  "block.minecraft.banner.stripe_top.light_blue": "Халлаан күөх төбө",
  "block.minecraft.banner.stripe_top.light_gray": "Улаан төбө",
  "block.minecraft.banner.stripe_top.lime": "Дьэҥкир күөх төбө",
  "block.minecraft.banner.stripe_top.magenta": "Хараҥа кыһыл төбө",
  "block.minecraft.banner.stripe_top.orange": "Чачархай төбө",
  "block.minecraft.banner.stripe_top.pink": "Оруосабай төбө",
  "block.minecraft.banner.stripe_top.purple": "Хара саарыл төбө",
  "block.minecraft.banner.stripe_top.red": "Кыһыл төбө",
  "block.minecraft.banner.stripe_top.white": "Маҥан төбө",
  "block.minecraft.banner.stripe_top.yellow": "Араҕас төбө",
  "block.minecraft.banner.triangle_bottom.black": "Хара уһук",
  "block.minecraft.banner.triangle_bottom.blue": "Күөх уһук",
  "block.minecraft.banner.triangle_bottom.brown": "Күрэҥ уһук",
  "block.minecraft.banner.triangle_bottom.cyan": "Бирюза уһук",
  "block.minecraft.banner.triangle_bottom.gray": "Сур уһук",
  "block.minecraft.banner.triangle_bottom.green": "От күөх уһук",
  "block.minecraft.banner.triangle_bottom.light_blue": "Халлаан күөх уһук",
  "block.minecraft.banner.triangle_bottom.light_gray": "Улаан уһук",
  "block.minecraft.banner.triangle_bottom.lime": "Дьэҥкир күөх уһук",
  "block.minecraft.banner.triangle_bottom.magenta": "Хараҥа кыһыл уһук",
  "block.minecraft.banner.triangle_bottom.orange": "Чачархай уһук",
  "block.minecraft.banner.triangle_bottom.pink": "Оруосабай уһук",
  "block.minecraft.banner.triangle_bottom.purple": "Хара саарыл уһук",
  "block.minecraft.banner.triangle_bottom.red": "Кыһыл уһук",
  "block.minecraft.banner.triangle_bottom.white": "Маҥан уһук",
  "block.minecraft.banner.triangle_bottom.yellow": "Араҕас уһук",
  "block.minecraft.banner.triangle_top.black": "Хара түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.blue": "Күөх түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.brown": "Күрэҥ түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.cyan": "Бирюза түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.gray": "Сур түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.green": "От күөх түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.light_blue": "Халлаан күөх түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.light_gray": "Улаан түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.lime": "Дьэҥкир күөх түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.magenta": "Хараҥа кыһыл түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.orange": "Чачархай түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.pink": "Оруосабай түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.purple": "Хара саарыл түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.red": "Кыһыл түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.white": "Маҥан түнҥэриллибит уһук",
  "block.minecraft.banner.triangle_top.yellow": "Араҕас түнҥэриллибит уһук",
  "block.minecraft.banner.triangles_bottom.black": "Хара ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.blue": "Күөх ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.brown": "Күрэҥ ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.cyan": "Бирюза ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.gray": "Сур ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.green": "От күөх ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.light_blue": "Халлаан күөх ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.light_gray": "Улаан ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.lime": "Дьэҥкир күөх ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.magenta": "Хараҥа кыһыл ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.orange": "Чачархай ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.pink": "Орусабай ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.purple": "Хара саарыл ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.red": "Кыһыл ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.white": "Маҥан ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_bottom.yellow": "Араҕас ойуттаҕас төрүт",
  "block.minecraft.banner.triangles_top.black": "Хара тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.blue": "Күөх тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.brown": "Күрэҥ тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.cyan": "Бирюза тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.gray": "Сур тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.green": "От күөх тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.light_blue": "Халлаан күөх тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.light_gray": "Улаан тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.lime": "Дьэҥкир күөх тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.magenta": "Хараҥа кыһыл тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.orange": "Чачархай тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.pink": "Орусабай тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.purple": "Хара саарыл тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.red": "Кыһыл тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.white": "Маҥан тиистэрдээх төбө",
  "block.minecraft.banner.triangles_top.yellow": "Араҕас тиистэрдээх төбө",
  "block.minecraft.barrel": "Буочука",
  "block.minecraft.barrier": "Мэһэй",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Маяк",
  "block.minecraft.beacon.primary": "Сүрүн дьайыы",
  "block.minecraft.beacon.secondary": "Иккис дьайыы",
  "block.minecraft.bed.no_sleep": "Түүн эбэтэр этиҥнээх ардах кэмигэр эрэ утуйуоххун сөп",
  "block.minecraft.bed.not_safe": "Утуйар кыаҕын суох; чугастыы абааһылар сылдьаллар",
  "block.minecraft.bed.obstructed": "Бу орон бүөлэнэн хаалбыт",
  "block.minecraft.bed.occupied": "Бу орон иллэҥэ суох",
  "block.minecraft.bed.too_far_away": "Утуйар кыаҕын суох; оронуҥ олус ыраах",
  "block.minecraft.bedrock": "Төрүт таас",
  "block.minecraft.bee_nest": "Тигээйи уйата",
  "block.minecraft.beehive": "Тигээйи уйата",
  "block.minecraft.beetroots": "Сүбүөкүлэ",
  "block.minecraft.bell": "Чуораан",
  "block.minecraft.big_dripleaf": "Улахан тамма-сэбирдэх",
  "block.minecraft.big_dripleaf_stem": "Улахан тамма-сэбирдэх умнаһа",
  "block.minecraft.birch_button": "Хатыҥ кунуопка",
  "block.minecraft.birch_door": "Хатыҥ аан",
  "block.minecraft.birch_fence": "Хатыҥ күрүө",
  "block.minecraft.birch_fence_gate": "Хатыҥ күрүө аана",
  "block.minecraft.birch_hanging_sign": "Хатыҥ ыйанар бэлиэ",
  "block.minecraft.birch_leaves": "Хатыҥ сэбирдэхтэрэ",
  "block.minecraft.birch_log": "Хатыҥ бэрэбинэтэ",
  "block.minecraft.birch_planks": "Хатыҥ хаптаһыннар",
  "block.minecraft.birch_pressure_plate": "Хатыҥ тэпсиллэр билиитэтэ",
  "block.minecraft.birch_sapling": "Хатыҥ талаҕа",
  "block.minecraft.birch_shelf": "Хатыҥ долбуур",
  "block.minecraft.birch_sign": "Хатыҥ бэлиэ",
  "block.minecraft.birch_slab": "Хатыҥ билиитэтэ",
  "block.minecraft.birch_stairs": "Хатыҥ үктэллэрэ",
  "block.minecraft.birch_trapdoor": "Хатыҥ лүүк аан",
  "block.minecraft.birch_wall_hanging_sign": "Хатыҥ истиэнэтээҕи бэлиэ",
  "block.minecraft.birch_wall_sign": "Хатыҥ истиэнэтээҕи бэлиэ",
  "block.minecraft.birch_wood": "Хатыҥ",
  "block.minecraft.black_banner": "Хара былаах",
  "block.minecraft.black_bed": "Хара орон",
  "block.minecraft.black_candle": "Хара чүмэчи",
  "block.minecraft.black_candle_cake": "Хара чүмэчилээх торт",
  "block.minecraft.black_carpet": "Хара көбүөр",
  "block.minecraft.black_concrete": "Хара бетон",
  "block.minecraft.black_concrete_powder": "Хара бетон бороһуока",
  "block.minecraft.black_glazed_terracotta": "Өстүөкэлэлэммит хара кэрээмикэ",
  "block.minecraft.black_shulker_box": "Хара шалкер дьааһыга",
  "block.minecraft.black_stained_glass": "Хара өстүөкүлэ",
  "block.minecraft.black_stained_glass_pane": "Хара чараас өстүөкүлэ",
  "block.minecraft.black_terracotta": "Хара кэрээмикэ",
  "block.minecraft.black_wool": "Хара түү",
  "block.minecraft.blackstone": "Хара таас",
  "block.minecraft.blackstone_slab": "Хара таас билиитэтэ",
  "block.minecraft.blackstone_stairs": "Хара таас үктэллэрэ",
  "block.minecraft.blackstone_wall": "Хара таас күрүөтэ",
  "block.minecraft.blast_furnace": "Тимир оһоҕо",
  "block.minecraft.blue_banner": "Күөх былыах",
  "block.minecraft.blue_bed": "Күөх орон",
  "block.minecraft.blue_candle": "Күөх чүмэчи",
  "block.minecraft.blue_candle_cake": "Күөх чүмэчилээх торт",
  "block.minecraft.blue_carpet": "Күөх көбүөр",
  "block.minecraft.blue_concrete": "Күөх бетон",
  "block.minecraft.blue_concrete_powder": "Күөх бетон бороһуога",
  "block.minecraft.blue_glazed_terracotta": "Өстүөкэлэлэммит күөх кэрээмикэ",
  "block.minecraft.blue_ice": "Күөх муус",
  "block.minecraft.blue_orchid": "Күөх архыдыайа",
  "block.minecraft.blue_shulker_box": "Күөх шалкер дьааһыга",
  "block.minecraft.blue_stained_glass": "Күөх өстүөкүлэ",
  "block.minecraft.blue_stained_glass_pane": "Күөх чараас өстүөкүлэ",
  "block.minecraft.blue_terracotta": "Күөх кэрээмикэ",
  "block.minecraft.blue_wool": "Күөх түү",
  "block.minecraft.bone_block": "Уҥуох булуога",
  "block.minecraft.bookshelf": "Кинигэ долбуура",
  "block.minecraft.brain_coral": "Мэйии коралл",
  "block.minecraft.brain_coral_block": "Мэйии коралл булуога",
  "block.minecraft.brain_coral_fan": "Мэйии коралл дэйбиирэ",
  "block.minecraft.brain_coral_wall_fan": "Мэйии коралл көнө дэйбиирэ",
  "block.minecraft.brewing_stand": "Аптаах ууну буһарар тэрил",
  "block.minecraft.brick_slab": "Кирпииччэ билиитэтэ",
  "block.minecraft.brick_stairs": "Кирпииччэ үктэллэрэ",
  "block.minecraft.brick_wall": "Кирпииччэ күрүө",
  "block.minecraft.bricks": "Кирпииччэлэр",
  "block.minecraft.brown_banner": "Күрэҥ былаах",
  "block.minecraft.brown_bed": "Күрэҥ ороҥ",
  "block.minecraft.brown_candle": "Хара тураҕас чүмэчи",
  "block.minecraft.brown_candle_cake": "Хара тураҕас чүмэчилээх торт",
  "block.minecraft.brown_carpet": "Күрэҥ көбүөр",
  "block.minecraft.brown_concrete": "Күрэҥ бетон",
  "block.minecraft.brown_concrete_powder": "Rүрэҥ бетон бороһуога",
  "block.minecraft.brown_glazed_terracotta": "Лаактах күрэҥ керамика",
  "block.minecraft.brown_mushroom": "Бороҥ тэллэй",
  "block.minecraft.brown_mushroom_block": "Бороҥ тэллэй булуога",
  "block.minecraft.brown_shulker_box": "Күрэҥ шалкер дьааһыга",
  "block.minecraft.brown_stained_glass": "Күрэҥ өстүөкүлэ",
  "block.minecraft.brown_stained_glass_pane": "Күрэҥ чараас өстүөкүлэ",
  "block.minecraft.brown_terracotta": "Күрэҥ керамика",
  "block.minecraft.brown_wool": "Күрэҥ түү",
  "block.minecraft.bubble_column": "Хабах колонната",
  "block.minecraft.bubble_coral": "Хабах коралл",
  "block.minecraft.bubble_coral_block": "Хабах коралл булуога",
  "block.minecraft.bubble_coral_fan": "Хабах коралл дэйбиирэ",
  "block.minecraft.bubble_coral_wall_fan": "Хабах коралл көнө дэйбиирэ",
  "block.minecraft.budding_amethyst": "Чэчирээн иһэр аметист",
  "block.minecraft.bush": "Сэппэрээк",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Кактус сибэккитэ",
  "block.minecraft.cake": "Бөрүөк",
  "block.minecraft.calcite": "Кальцит",
  "block.minecraft.calibrated_sculk_sensor": "Халыыбырдаммыт скалк сенсор",
  "block.minecraft.campfire": "Оттуллубут уот",
  "block.minecraft.candle": "Чүмэчи",
  "block.minecraft.candle_cake": "Чүмэчилээх торт",
  "block.minecraft.carrots": "Моркуоп",
  "block.minecraft.cartography_table": "Сирдьит остуола",
  "block.minecraft.carved_pumpkin": "Быһыллыбыт тыыкыба",
  "block.minecraft.cauldron": "Солуур",
  "block.minecraft.cave_air": "Хаспах салгына",
  "block.minecraft.cave_vines": "Хаспах лианалара",
  "block.minecraft.cave_vines_plant": "Хаспах лианаларын умнаһа",
  "block.minecraft.chain": "Сыап",
  "block.minecraft.chain_command_block": "Хамаандалар сыаптарын булуога",
  "block.minecraft.cherry_button": "Вишня маһыттан кнопка",
  "block.minecraft.cherry_door": "Вишня маһыттан аан",
  "block.minecraft.cherry_fence": "Вишня маһыттан күрүө",
  "block.minecraft.cherry_fence_gate": "Вишня маһыттан күрүө аана",
  "block.minecraft.cherry_hanging_sign": "Вишня маһыттан ыйанар бэлиэ",
  "block.minecraft.cherry_leaves": "Вишня сэбирдэхтэрэ",
  "block.minecraft.cherry_log": "Вишня маһын бэрэбинэтэ",
  "block.minecraft.cherry_planks": "Вишня маһыттан хаптаһын",
  "block.minecraft.cherry_pressure_plate": "Вишня тэпсиллэр билиитэтэ",
  "block.minecraft.cherry_sapling": "Вишня олордор мас",
  "block.minecraft.cherry_shelf": "Вишня мас долбуур",
  "block.minecraft.cherry_sign": "Вишня ыйанар бэлиэ",
  "block.minecraft.cherry_slab": "Вишня маһыттан билиитэтэ",
  "block.minecraft.cherry_stairs": "Вишня маһыттан үктэл",
  "block.minecraft.cherry_trapdoor": "Вишня маһыттан люк",
  "block.minecraft.cherry_wall_hanging_sign": "Вишня маһыттан истиэнэтээҕи бэлиэ",
  "block.minecraft.cherry_wall_sign": "Истиэнэҕэ ыйанар вишняттан бэлиэ",
  "block.minecraft.cherry_wood": "Вишня",
  "block.minecraft.chest": "Дьааһык",
  "block.minecraft.chipped_anvil": "Хайдыбыт кыстык",
  "block.minecraft.chiseled_bookshelf": "Ойуттаҕас кинигэ долбуура",
  "block.minecraft.chiseled_copper": "Ойуттаҕас алтан",
  "block.minecraft.chiseled_deepslate": "Ойуттаҕас дириҥнээҕи таас",
  "block.minecraft.chiseled_nether_bricks": "Ойуттаҕас Незер кирпиччэлэрэ",
  "block.minecraft.chiseled_polished_blackstone": "Ойуттаҕас аалыллыбыт хара таас",
  "block.minecraft.chiseled_quartz_block": "Ойуттаҕас кварц булуога",
  "block.minecraft.chiseled_red_sandstone": "Ойуттаҕас кыһыл кумах таас",
  "block.minecraft.chiseled_resin_bricks": "Ойуттаҕас сымала кирпииччэлэр",
  "block.minecraft.chiseled_sandstone": "Ойуттаҕас кумах таас",
  "block.minecraft.chiseled_stone_bricks": "Ойуттаҕас таас кирпиччэлэрэ",
  "block.minecraft.chiseled_tuff": "Ойуттаҕас тууф",
  "block.minecraft.chiseled_tuff_bricks": "Ойуттаҕас тууф кирпииччэлэр",
  "block.minecraft.chorus_flower": "Хуорус сибэккитэ",
  "block.minecraft.chorus_plant": "Хуорус",
  "block.minecraft.clay": "Туой",
  "block.minecraft.closed_eyeblossom": "Сабыллыбыт харах тылллыыта",
  "block.minecraft.coal_block": "Чох булуога",
  "block.minecraft.coal_ore": "Таас чох урууда",
  "block.minecraft.coarse_dirt": "Таастаах буор",
  "block.minecraft.cobbled_deepslate": "Хайытыллыбыт дириҥнээҕи таас",
  "block.minecraft.cobbled_deepslate_slab": "Хайытыллыбыт дириҥнээҕи таас билиитэтэ",
  "block.minecraft.cobbled_deepslate_stairs": "Хайытыллыбыт дириҥнээҕи таас үктэллэр",
  "block.minecraft.cobbled_deepslate_wall": "Хайытыллыбыт дириҥнээҕи таас күрүө",
  "block.minecraft.cobblestone": "Күрбэ таас",
  "block.minecraft.cobblestone_slab": "Күрбэ таас билиитэтэ",
  "block.minecraft.cobblestone_stairs": "Күрбэ таас үктэллэрэ",
  "block.minecraft.cobblestone_wall": "Күрбэ таас күрүө",
  "block.minecraft.cobweb": "Ооҕуй ситимэ",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Хамаандалар булуоктара",
  "block.minecraft.comparator": "Редстоун тэҥнээччи",
  "block.minecraft.composter": "Сытынньаҥ буочуката",
  "block.minecraft.conduit": "Байҕал тымыра",
  "block.minecraft.copper_bars": "Алтан талахтар",
  "block.minecraft.copper_block": "Алтан булуога",
  "block.minecraft.copper_bulb": "Алтан лаампа",
  "block.minecraft.copper_chain": "Алтан сыап",
  "block.minecraft.copper_chest": "Алтан сундуук",
  "block.minecraft.copper_door": "Алтан аан",
  "block.minecraft.copper_golem_statue": "Алтан голем статуйата",
  "block.minecraft.copper_grate": "Алтан эрэһээҥки",
  "block.minecraft.copper_lantern": "Алтан банаар",
  "block.minecraft.copper_ore": "Алтан урууда",
  "block.minecraft.copper_torch": "Алтан факел",
  "block.minecraft.copper_trapdoor": "Алтан лүүк",
  "block.minecraft.copper_wall_torch": "Алтан истиэнэ факела",
  "block.minecraft.cornflower": "Күөх сибэкки",
  "block.minecraft.cracked_deepslate_bricks": "Хайдыбыт дириҥнээҕи таас кирпииччэ",
  "block.minecraft.cracked_deepslate_tiles": "Хайдыбыт дириҥнээҕи таас билииткэ",
  "block.minecraft.cracked_nether_bricks": "Хайдыбыт Незер кирпииччэ",
  "block.minecraft.cracked_polished_blackstone_bricks": "Хайдыбыт аалыллыбыт хара таас кирпииччэлэр",
  "block.minecraft.cracked_stone_bricks": "Хайдыбыт таас кирпииччэ",
  "block.minecraft.crafter": "Оҥорооччу",
  "block.minecraft.crafting_table": "Бэрэстээк",
  "block.minecraft.creaking_heart": "Кыычырҕааччы сүрэҕэ",
  "block.minecraft.creeper_head": "Крипер төбөтө",
  "block.minecraft.creeper_wall_head": "Истиэнэтээҕи крипер төбөтө",
  "block.minecraft.crimson_button": "Өһөх өҥнөөх кунуопка",
  "block.minecraft.crimson_door": "Өһөх өҥнөөх мас аан",
  "block.minecraft.crimson_fence": "Өһөх өҥнөөх мас күрүө",
  "block.minecraft.crimson_fence_gate": "Өһөх өҥнөөх мас күрүө аана",
  "block.minecraft.crimson_fungus": "Өһөх өҥнөөх тэллэй",
  "block.minecraft.crimson_hanging_sign": "Өһөх өҥнөөх мас ыйанар бэлиэ",
  "block.minecraft.crimson_hyphae": "Өһөх өҥнөөх тэллэй силистэрэ",
  "block.minecraft.crimson_nylium": "Өһөх өҥнөөх ниилий",
  "block.minecraft.crimson_planks": "Өһөх өҥнөөх хаптаһын",
  "block.minecraft.crimson_pressure_plate": "Өһөх өҥнөөх мас тэпсиллэр билиитэтэ",
  "block.minecraft.crimson_roots": "Өһөх өҥнөөх силистэр",
  "block.minecraft.crimson_shelf": "Өһөх өҥнөөх долбуур",
  "block.minecraft.crimson_sign": "Өһөх өҥнөөх бэлиэ",
  "block.minecraft.crimson_slab": "Өһөх өҥнөөх мас билиитэтэ",
  "block.minecraft.crimson_stairs": "Өһөх өҥнөөх мас үктэллэрэ",
  "block.minecraft.crimson_stem": "Өһөх өҥнөөх умнас",
  "block.minecraft.crimson_trapdoor": "Өһөх өҥнөөх мас лүүк аана",
  "block.minecraft.crimson_wall_hanging_sign": "Өһөх өҥнөөх мас истиэнэтээҕи бэлиэ",
  "block.minecraft.crimson_wall_sign": "Өһөх өҥнөөх мас истиэнэтээҕи бэлиэ",
  "block.minecraft.crying_obsidian": "Ытамньыйар Обсидиан",
  "block.minecraft.cut_copper": "Ойуттаҕас алтан булуога",
  "block.minecraft.cut_copper_slab": "Ойуттаҕас алтан билиитэтэ",
  "block.minecraft.cut_copper_stairs": "Ойуттаҕас алтан үктэллэр",
  "block.minecraft.cut_red_sandstone": "Суоруллубут кыһыл кумах таас",
  "block.minecraft.cut_red_sandstone_slab": "Суоруллубут кыһыл кумах таас билиитэтэ",
  "block.minecraft.cut_sandstone": "Суоруллубут кумах таас",
  "block.minecraft.cut_sandstone_slab": "Суоруллубут кумах таас билиитэтэ",
  "block.minecraft.cyan_banner": "Бирюза былаах",
  "block.minecraft.cyan_bed": "Бирюза орон",
  "block.minecraft.cyan_candle": "Бирюза чүмэчи",
  "block.minecraft.cyan_candle_cake": "Бирюза чүмэчилээх торт",
  "block.minecraft.cyan_carpet": "Бирюза көбүөр",
  "block.minecraft.cyan_concrete": "Бирюза бетон",
  "block.minecraft.cyan_concrete_powder": "Бирюза бетон бороһуога",
  "block.minecraft.cyan_glazed_terracotta": "Өстүөкэлэлэммит бирюза кэрээмикэ",
  "block.minecraft.cyan_shulker_box": "Бирюза шалкер дьааһыга",
  "block.minecraft.cyan_stained_glass": "Бирюза өстүөкүлэ",
  "block.minecraft.cyan_stained_glass_pane": "Бирюза чараас өстүөкүлэ",
  "block.minecraft.cyan_terracotta": "Бирюза кэрээмикэ",
  "block.minecraft.cyan_wool": "Бирюза түү",
  "block.minecraft.damaged_anvil": "Алдьаммыт кыстык",
  "block.minecraft.dandelion": "Алтан төбө",
  "block.minecraft.dark_oak_button": "Хара дууп кунуопка",
  "block.minecraft.dark_oak_door": "Хара дууп аан",
  "block.minecraft.dark_oak_fence": "Хара дууп күрүө",
  "block.minecraft.dark_oak_fence_gate": "Хара дууп күрүө аана",
  "block.minecraft.dark_oak_hanging_sign": "Хара дууп ыйанар бэлиэ",
  "block.minecraft.dark_oak_leaves": "Хара дууп сэбирдэхтэрэ",
  "block.minecraft.dark_oak_log": "Хара дууп бэрэбинэтэ",
  "block.minecraft.dark_oak_planks": "Хара дууп хаптаһыннар",
  "block.minecraft.dark_oak_pressure_plate": "Хара дууп тэпсиллэр билиитэтэ",
  "block.minecraft.dark_oak_sapling": "Хара дууп талаҕа",
  "block.minecraft.dark_oak_shelf": "Хара дууп долбуур",
  "block.minecraft.dark_oak_sign": "Хара дууп бэлиэ",
  "block.minecraft.dark_oak_slab": "Хара дууп билиитэтэ",
  "block.minecraft.dark_oak_stairs": "Хара дууп үктэллэрэ",
  "block.minecraft.dark_oak_trapdoor": "Хара дууп лүүк аан",
  "block.minecraft.dark_oak_wall_hanging_sign": "Хара дууп истиэнэтээҕи бэлиэ",
  "block.minecraft.dark_oak_wall_sign": "Хара дууп истиэнэтээҕи бэлиэ",
  "block.minecraft.dark_oak_wood": "Хара дууп",
  "block.minecraft.dark_prismarine": "Хара призмарин",
  "block.minecraft.dark_prismarine_slab": "Хара призмарин билиитэтэ",
  "block.minecraft.dark_prismarine_stairs": "Хара призмарин үктэллэрэ",
  "block.minecraft.daylight_detector": "Сырдык датчига",
  "block.minecraft.dead_brain_coral": "Өлбүт мэйии коралл",
  "block.minecraft.dead_brain_coral_block": "Өлбүт мэйии коралл булуога",
  "block.minecraft.dead_brain_coral_fan": "Өлбүт мэйии коралл дэйбиирэ",
  "block.minecraft.dead_brain_coral_wall_fan": "Өлбүт мэйии коралл көнө дэйбиирэ",
  "block.minecraft.dead_bubble_coral": "Өлбүт хабах коралл",
  "block.minecraft.dead_bubble_coral_block": "Өлбүт хабах коралл булуога",
  "block.minecraft.dead_bubble_coral_fan": "Өлбүт хабах коралл дэйбиирэ",
  "block.minecraft.dead_bubble_coral_wall_fan": "Өлбүт хабах коралл көнө дэйбиирэ",
  "block.minecraft.dead_bush": "Өлбүт сэппэрээк",
  "block.minecraft.dead_fire_coral": "Өлбүт төлөн коралл",
  "block.minecraft.dead_fire_coral_block": "Өлбүт төлөн коралл булуога",
  "block.minecraft.dead_fire_coral_fan": "Өлбүт төлөн коралл дэйбиирэ",
  "block.minecraft.dead_fire_coral_wall_fan": "Өлбүт төлөн коралл көнө дэйбиирэ",
  "block.minecraft.dead_horn_coral": "Өлбүт муос коралл",
  "block.minecraft.dead_horn_coral_block": "Өлбүт муос коралл булуога",
  "block.minecraft.dead_horn_coral_fan": "Өлбүт муос коралл дэйбиирэ",
  "block.minecraft.dead_horn_coral_wall_fan": "Өлбүт муос коралл көнө дэйбиирэ",
  "block.minecraft.dead_tube_coral": "Өлбүт турба коралл",
  "block.minecraft.dead_tube_coral_block": "Өлбүт турба коралл булуога",
  "block.minecraft.dead_tube_coral_fan": "Өлбүт турба коралл дэйбиирэ",
  "block.minecraft.dead_tube_coral_wall_fan": "Өлбүт турба коралл көнө дэйбиирэ",
  "block.minecraft.decorated_pot": "Киэргэллэх үүгээйи иһитэ",
  "block.minecraft.deepslate": "Дириҥнээҕи таас",
  "block.minecraft.deepslate_brick_slab": "Дириҥнээҕи таас кирпииччэлэр билиитэлэрэ",
  "block.minecraft.deepslate_brick_stairs": "Дириҥнээҕи таас кирпииччэлэр үктэллэрэ",
  "block.minecraft.deepslate_brick_wall": "Дириҥнээҕи таас кирпииччэлэртэн күрүө",
  "block.minecraft.deepslate_bricks": "Дириҥнээҕи таас кирпииччэлэр",
  "block.minecraft.deepslate_coal_ore": "Чохтоох дириҥнээҕи боруода",
  "block.minecraft.deepslate_copper_ore": "Алтаннаах дириҥнээҕи боруода",
  "block.minecraft.deepslate_diamond_ore": "Алмаастаах дириҥнээҕи боруода",
  "block.minecraft.deepslate_emerald_ore": "Изумрудтаах дириҥнээҕи боруода",
  "block.minecraft.deepslate_gold_ore": "Кыһыл көмүстээх дириҥнээҕи боруода",
  "block.minecraft.deepslate_iron_ore": "Тимирдээх дириҥнээҕи боруода",
  "block.minecraft.deepslate_lapis_ore": "Лазуриттаах дириҥнээҕи боруода",
  "block.minecraft.deepslate_redstone_ore": "Редстоуннаах дириҥнээҕи боруода",
  "block.minecraft.deepslate_tile_slab": "Дириҥнээҕи таас билииткэ билиитэтэ",
  "block.minecraft.deepslate_tile_stairs": "Дириҥнээҕи таас билииткэ үктэллэр",
  "block.minecraft.deepslate_tile_wall": "Дириҥнээҕи таас билииткэ күрүө",
  "block.minecraft.deepslate_tiles": "Дириҥнээҕи таас билииткэ",
  "block.minecraft.detector_rail": "Датчиктаах тимир суол",
  "block.minecraft.diamond_block": "Алмаас булуога",
  "block.minecraft.diamond_ore": "Алмаас урууда",
  "block.minecraft.diorite": "Диэриит",
  "block.minecraft.diorite_slab": "Диэриит билиитэтэ",
  "block.minecraft.diorite_stairs": "Диэриит үктэллэрэ",
  "block.minecraft.diorite_wall": "Диэриит күрүө",
  "block.minecraft.dirt": "Буор",
  "block.minecraft.dirt_path": "Суол",
  "block.minecraft.dispenser": "Биэрээччи",
  "block.minecraft.dragon_egg": "Уот моҕой сымыыта",
  "block.minecraft.dragon_head": "Уот моҕой төбөтө",
  "block.minecraft.dragon_wall_head": "Истиэнэтээҕи уот моҕой төбөтө",
  "block.minecraft.dried_ghast": "Утаппыт гаст",
  "block.minecraft.dried_kelp_block": "Хатарыллыбыт салахай булуога",
  "block.minecraft.dripstone_block": "Таммаламмыт таас булуога",
  "block.minecraft.dropper": "Быраҕааччы",
  "block.minecraft.emerald_block": "Изумруд булуога",
  "block.minecraft.emerald_ore": "Изумруд урууда",
  "block.minecraft.enchanting_table": "Аптаах остуол",
  "block.minecraft.end_gateway": "Энд аана",
  "block.minecraft.end_portal": "Энд аана",
  "block.minecraft.end_portal_frame": "Энд аанын араамата",
  "block.minecraft.end_rod": "Энд үөһэ",
  "block.minecraft.end_stone": "Эндер-таас",
  "block.minecraft.end_stone_brick_slab": "Эндер-таас кирпииччэ билиитэтэ",
  "block.minecraft.end_stone_brick_stairs": "Эндер-таас кирпииччэ үктэллэрэ",
  "block.minecraft.end_stone_brick_wall": "Эндер-таас кирпииччэттэн күрүө",
  "block.minecraft.end_stone_bricks": "Эндер-таас кирпииччэ",
  "block.minecraft.ender_chest": "Эндер дьааһыга",
  "block.minecraft.exposed_chiseled_copper": "Хараарбыт ойуттаҕас алтан",
  "block.minecraft.exposed_copper": "Хараарбыт алтан булуога",
  "block.minecraft.exposed_copper_bars": "Хараарбыт алтан талахтар",
  "block.minecraft.exposed_copper_bulb": "Хараарбыт алтан лаампата",
  "block.minecraft.exposed_copper_chain": "Хараарбыт алтан сыап",
  "block.minecraft.exposed_copper_chest": "Хараарбыт алтан сундуук",
  "block.minecraft.exposed_copper_door": "Хараарбыт алтан аана",
  "block.minecraft.exposed_copper_golem_statue": "Хараарбыт алтан голем статуйата",
  "block.minecraft.exposed_copper_grate": "Хараарбыт алтан хаххата",
  "block.minecraft.exposed_copper_lantern": "Хараарбыт алтан банаар",
  "block.minecraft.exposed_copper_trapdoor": "Хараарбыт алтан люга",
  "block.minecraft.exposed_cut_copper": "Хараарбыт ойуттаҕас алтан булуога",
  "block.minecraft.exposed_cut_copper_slab": "Хараарбыт алтан ойуттаҕас билиитэтэ",
  "block.minecraft.exposed_cut_copper_stairs": "Хараарбыт алтан ойуттаҕас үктэллэрэ",
  "block.minecraft.exposed_lightning_rod": "Хараарбыт этиҥи аһарааччы",
  "block.minecraft.farmland": "Бааһына",
  "block.minecraft.fern": "Таас от",
  "block.minecraft.fire": "Төлөн",
  "block.minecraft.fire_coral": "Төлөн коралл",
  "block.minecraft.fire_coral_block": "Төлөн коралл булуога",
  "block.minecraft.fire_coral_fan": "Төлөн коралл дэйбиирэ",
  "block.minecraft.fire_coral_wall_fan": "Хабах коралл көнө дэйбиирэ",
  "block.minecraft.firefly_bush": "Светлячоктаах сэппэрээк",
  "block.minecraft.fletching_table": "Охчут остуола",
  "block.minecraft.flower_pot": "Үүнэйи иһитэ",
  "block.minecraft.flowering_azalea": "Сибэккилэммит азалия",
  "block.minecraft.flowering_azalea_leaves": "Сибэккилэммит азалия сэбирдэхтэрэ",
  "block.minecraft.frogspawn": "Баҕа сымыыта",
  "block.minecraft.frosted_ice": "Ириэнэх муус",
  "block.minecraft.furnace": "Оһох",
  "block.minecraft.gilded_blackstone": "Солотуулаах хара таас",
  "block.minecraft.glass": "Өстүөкүлэ",
  "block.minecraft.glass_pane": "Чараас өстүөкүлэ",
  "block.minecraft.glow_lichen": "Тыгар лабыкта",
  "block.minecraft.glowstone": "Сырдык таас",
  "block.minecraft.gold_block": "Көмүс булуога",
  "block.minecraft.gold_ore": "Көмүс урууда",
  "block.minecraft.golden_dandelion": "Кыһыл көмүс ньээм",
  "block.minecraft.granite": "Кыраньыыт",
  "block.minecraft.granite_slab": "Кыраньыыт билиитэтэ",
  "block.minecraft.granite_stairs": "Кыраньыыт үктэллэрэ",
  "block.minecraft.granite_wall": "Кыраньыыт күрүө",
  "block.minecraft.grass": "От",
  "block.minecraft.grass_block": "От",
  "block.minecraft.gravel": "Чай таас",
  "block.minecraft.gray_banner": "Сур былаах",
  "block.minecraft.gray_bed": "Сур орон",
  "block.minecraft.gray_candle": "Сур чүмэчи",
  "block.minecraft.gray_candle_cake": "Сур чүмэчилээх торт",
  "block.minecraft.gray_carpet": "Сур көбүөр",
  "block.minecraft.gray_concrete": "Сур бетон",
  "block.minecraft.gray_concrete_powder": "Сур бетон бороһуога",
  "block.minecraft.gray_glazed_terracotta": "Өстүөкэлэлэммит сур кэрээмикэ",
  "block.minecraft.gray_shulker_box": "Сур шалкер дьааһыга",
  "block.minecraft.gray_stained_glass": "Сур өстүөкүлэ",
  "block.minecraft.gray_stained_glass_pane": "Сур чараас өстүөкүлэ",
  "block.minecraft.gray_terracotta": "Сур кэрээмикэ",
  "block.minecraft.gray_wool": "Сур түү",
  "block.minecraft.green_banner": "От күөх былаах",
  "block.minecraft.green_bed": "От күөх орон",
  "block.minecraft.green_candle": "От - күөх чүмэчи",
  "block.minecraft.green_candle_cake": "От күөх чүмэчилээх торт",
  "block.minecraft.green_carpet": "От күөх көбүөр",
  "block.minecraft.green_concrete": "От күөх бетон",
  "block.minecraft.green_concrete_powder": "От күөх бетон бороһуога",
  "block.minecraft.green_glazed_terracotta": "Өстүөкэлэлэммит от күөх кэрээмикэ",
  "block.minecraft.green_shulker_box": "От күөх шалкер дьааһыга",
  "block.minecraft.green_stained_glass": "От күөх өстүөкүлэ",
  "block.minecraft.green_stained_glass_pane": "От күөх чараас өстүөкүлэ",
  "block.minecraft.green_terracotta": "От күөх кэрээмикэ",
  "block.minecraft.green_wool": "От күөх түү",
  "block.minecraft.grindstone": "Чочу",
  "block.minecraft.hanging_roots": "Намылыйбыт силистэр",
  "block.minecraft.hay_block": "Түүтэх от",
  "block.minecraft.heavy_core": "Уус Таас",
  "block.minecraft.heavy_weighted_pressure_plate": "Кытаанах ыйааһын билиитэтэ",
  "block.minecraft.honey_block": "Мүөт булуога",
  "block.minecraft.honeycomb_block": "Тигээйии уйатын мүөт булуога",
  "block.minecraft.hopper": "Боруоҥка",
  "block.minecraft.horn_coral": "Муос коралл",
  "block.minecraft.horn_coral_block": "Муос коралл булуога",
  "block.minecraft.horn_coral_fan": "Муос коралл дэйбиирэ",
  "block.minecraft.horn_coral_wall_fan": "Муос коралл көнө дэйбиирэ",
  "block.minecraft.ice": "Муус",
  "block.minecraft.infested_chiseled_stone_bricks": "Үөннэммит ойуттаҕас таас кирпииччэлэр",
  "block.minecraft.infested_cobblestone": "Үөннэммит күрбэ таас",
  "block.minecraft.infested_cracked_stone_bricks": "Үөннэммит алдьаммыт таас кирпииччэлэр",
  "block.minecraft.infested_deepslate": "Үөннэммит дириҥнээҕи таас",
  "block.minecraft.infested_mossy_stone_bricks": "Үөннэммит муохтаммыт таас кирпииччэлэр",
  "block.minecraft.infested_stone": "Үөннэммит таас",
  "block.minecraft.infested_stone_bricks": "Үөннэммит таас кирпииччэлэр",
  "block.minecraft.iron_bars": "Тимир эрэһээҥкэ",
  "block.minecraft.iron_block": "Тимир булуога",
  "block.minecraft.iron_chain": "Тимир сыап",
  "block.minecraft.iron_door": "Тимир аан",
  "block.minecraft.iron_ore": "Тимир урууда",
  "block.minecraft.iron_trapdoor": "Тимир лүүк аан",
  "block.minecraft.jack_o_lantern": "Джэк лаампата",
  "block.minecraft.jigsaw": "Пазл",
  "block.minecraft.jukebox": "Муусука булуога",
  "block.minecraft.jungle_button": "Соҕурууҥу мас кунуопка",
  "block.minecraft.jungle_door": "Соҕурууҥу мас аан",
  "block.minecraft.jungle_fence": "Соҕурууҥу мас күрүө",
  "block.minecraft.jungle_fence_gate": "Соҕурууҥу мас күрүө аана",
  "block.minecraft.jungle_hanging_sign": "Соҕурууҥу мас ыйанар бэлиэ",
  "block.minecraft.jungle_leaves": "Соҕурууҥу мас сэбирдэхтэрэ",
  "block.minecraft.jungle_log": "Соҕурууҥу мас бэрэбинэтэ",
  "block.minecraft.jungle_planks": "Соҕурууҥу мас хаптаһыннар",
  "block.minecraft.jungle_pressure_plate": "Соҕурууҥу мас тэпсиллэр билиитэтэ",
  "block.minecraft.jungle_sapling": "Соҕурууҥу мас талаҕа",
  "block.minecraft.jungle_shelf": "Тропическай мас долбууур",
  "block.minecraft.jungle_sign": "Соҕурууҥу мас бэлиэ",
  "block.minecraft.jungle_slab": "Соҕурууҥу мас билиитэтэ",
  "block.minecraft.jungle_stairs": "Соҕурууҥу мас үктэллэрэ",
  "block.minecraft.jungle_trapdoor": "Соҕурууҥу мас лүүк аан",
  "block.minecraft.jungle_wall_hanging_sign": "Соҕурууҥу мас истиэнэтээҕи бэлиэ",
  "block.minecraft.jungle_wall_sign": "Соҕурууҥу мас истиэнэтээҕи бэлиэ",
  "block.minecraft.jungle_wood": "Соҕурууҥу мас",
  "block.minecraft.kelp": "Салахай",
  "block.minecraft.kelp_plant": "Салахай умнаһа",
  "block.minecraft.ladder": "Кирилиэс",
  "block.minecraft.lantern": "Лаампа",
  "block.minecraft.lapis_block": "Лазурит булуога",
  "block.minecraft.lapis_ore": "Лазурит урууда",
  "block.minecraft.large_amethyst_bud": "Улахан аметист үөскэҕэ",
  "block.minecraft.large_fern": "Улахан таас от",
  "block.minecraft.lava": "Лааба",
  "block.minecraft.lava_cauldron": "Лаабалаах солуур",
  "block.minecraft.leaf_litter": "Кураанах сэбирдэхтэр",
  "block.minecraft.lectern": "Кафедра",
  "block.minecraft.lever": "Ырычаах",
  "block.minecraft.light": "Сырдык",
  "block.minecraft.light_blue_banner": "Халлаан күөх былаах",
  "block.minecraft.light_blue_bed": "Халлаан күөх орон",
  "block.minecraft.light_blue_candle": "Халлаан күөх чүмэчи",
  "block.minecraft.light_blue_candle_cake": "Халлаан күөх чүмэчилээх торт",
  "block.minecraft.light_blue_carpet": "Халлаан күөх көбүөр",
  "block.minecraft.light_blue_concrete": "Халлаан күөх бетон",
  "block.minecraft.light_blue_concrete_powder": "Халлаан күөх бетон бороһуога",
  "block.minecraft.light_blue_glazed_terracotta": "Өстүөкэлэлэммит халлаан күөх кэрээмикэ",
  "block.minecraft.light_blue_shulker_box": "Халлаан күөх шалкер дьааһыга",
  "block.minecraft.light_blue_stained_glass": "Халлаан күөх өстүөкүлэ",
  "block.minecraft.light_blue_stained_glass_pane": "Халллаан күөх чараас өстүөкүлэ",
  "block.minecraft.light_blue_terracotta": "Халлаан күөх кэрээмикэ",
  "block.minecraft.light_blue_wool": "Халлаан күөх түү",
  "block.minecraft.light_gray_banner": "Улаан былаах",
  "block.minecraft.light_gray_bed": "Улаан орон",
  "block.minecraft.light_gray_candle": "Улаан чүмэчи",
  "block.minecraft.light_gray_candle_cake": "Улаан чүмэчилээх торт",
  "block.minecraft.light_gray_carpet": "Улаан көбүөр",
  "block.minecraft.light_gray_concrete": "Улаан бетон",
  "block.minecraft.light_gray_concrete_powder": "Улаан бетон бороһуога",
  "block.minecraft.light_gray_glazed_terracotta": "Өстүөкэлэлэммит улаан кэрээмикэ",
  "block.minecraft.light_gray_shulker_box": "Улаан шалкер дьааһыга",
  "block.minecraft.light_gray_stained_glass": "Улаан өстүөкүлэ",
  "block.minecraft.light_gray_stained_glass_pane": "Улаан чараас өстүөкүлэ",
  "block.minecraft.light_gray_terracotta": "Улаан кэрээмикэ",
  "block.minecraft.light_gray_wool": "Улаан түү",
  "block.minecraft.light_weighted_pressure_plate": "Ыйааһын билиитэтэ",
  "block.minecraft.lightning_rod": "Этиҥи аһарааччы",
  "block.minecraft.lilac": "Сириэн",
  "block.minecraft.lily_of_the_valley": "Лаандыс",
  "block.minecraft.lily_pad": "Уу сардааната",
  "block.minecraft.lime_banner": "Дьэҥкир күөх былаах",
  "block.minecraft.lime_bed": "Дьэҥкир күөх орон",
  "block.minecraft.lime_candle": "Дьэҥкир күөх чүмэчи",
  "block.minecraft.lime_candle_cake": "Дьэҥкир күөх чүмэчилээх торт",
  "block.minecraft.lime_carpet": "Дьэҥкир күөх көбүөр",
  "block.minecraft.lime_concrete": "Дьэҥкир күөх бетон",
  "block.minecraft.lime_concrete_powder": "Дьэҥкир күөх бетон бороһуока",
  "block.minecraft.lime_glazed_terracotta": "Өстүөкэлэлэммит дьэҥкир от күөх кэрээмикэ",
  "block.minecraft.lime_shulker_box": "Дьэҥкир күөх шалкер дьааһыга",
  "block.minecraft.lime_stained_glass": "Дьэҥкир күөх өстүөкүлэ",
  "block.minecraft.lime_stained_glass_pane": "Дьэҥкир күөх чараас өстүөкүлэ",
  "block.minecraft.lime_terracotta": "Дьэҥкир күөх кэрээмикэ",
  "block.minecraft.lime_wool": "Дьэҥкир күөх түү",
  "block.minecraft.lodestone": "Магниттаах таас",
  "block.minecraft.loom": "Таҥас өрөр тэрил",
  "block.minecraft.magenta_banner": "Хараҥа кыһыл былаах",
  "block.minecraft.magenta_bed": "Хараҥа кыһыл орон",
  "block.minecraft.magenta_candle": "Хараҥа кыһыл чүмэчи",
  "block.minecraft.magenta_candle_cake": "Хараҥа кыһыл чүмэчилээх торт",
  "block.minecraft.magenta_carpet": "Хараҥа кыһыл көбүөр",
  "block.minecraft.magenta_concrete": "Хараҥа кыһыл бетон",
  "block.minecraft.magenta_concrete_powder": "Хараҥа кыһыл бетон бороһуога",
  "block.minecraft.magenta_glazed_terracotta": "Өстүөкэлэлэммит хараҥа кыһыл кэрээмикэ",
  "block.minecraft.magenta_shulker_box": "Хараҥа кыһыл шалкер дьааһыга",
  "block.minecraft.magenta_stained_glass": "Хараҥа кыһыл өстүөкүлэ",
  "block.minecraft.magenta_stained_glass_pane": "Хараҥа кыһыл чараас өстүөкүлэ",
  "block.minecraft.magenta_terracotta": "Хараҥа кыһыл кэрээмикэ",
  "block.minecraft.magenta_wool": "Хараҥа кыһыл түү",
  "block.minecraft.magma_block": "Магма булуога",
  "block.minecraft.mangrove_button": "Мангра мас кунуопка",
  "block.minecraft.mangrove_door": "Мангра мас аан",
  "block.minecraft.mangrove_fence": "Мангра мас күрүө",
  "block.minecraft.mangrove_fence_gate": "Мангра мас күрүө аана",
  "block.minecraft.mangrove_hanging_sign": "Мангра мас ыйанар бэлиэ",
  "block.minecraft.mangrove_leaves": "Мангра мас сэбирдэхтэрэ",
  "block.minecraft.mangrove_log": "Мангра мас бэрэбинэ",
  "block.minecraft.mangrove_planks": "Мангра хаптаһыннар",
  "block.minecraft.mangrove_pressure_plate": "Мангра мас тэпсиллэр билиитэтэ",
  "block.minecraft.mangrove_propagule": "Мангра үүнээйитэ",
  "block.minecraft.mangrove_roots": "Мангра мас силистэрэ",
  "block.minecraft.mangrove_shelf": "Мангра мас долбуур",
  "block.minecraft.mangrove_sign": "Мангра мас бэлиэ",
  "block.minecraft.mangrove_slab": "Мангра мас билиитэтэ",
  "block.minecraft.mangrove_stairs": "Мангра мас үктэллэрэ",
  "block.minecraft.mangrove_trapdoor": "Мангра мас лүүк аана",
  "block.minecraft.mangrove_wall_hanging_sign": "Мангра мас истиэнэтээҕи бэлиэ",
  "block.minecraft.mangrove_wall_sign": "Мангра мас истиэнэтээҕи бэлиэ",
  "block.minecraft.mangrove_wood": "Мангра мас",
  "block.minecraft.medium_amethyst_bud": "Орто аметист үөскэҕэ",
  "block.minecraft.melon": "Арбуус",
  "block.minecraft.melon_stem": "Арбуус умнаһа",
  "block.minecraft.moss_block": "Муох булуога",
  "block.minecraft.moss_carpet": "Муох көбүөрэ",
  "block.minecraft.mossy_cobblestone": "Муохтаммыт күрбэ таас",
  "block.minecraft.mossy_cobblestone_slab": "Муохтаммыт күрбэ таас билиитэтэ",
  "block.minecraft.mossy_cobblestone_stairs": "Муохтаммыт күрбэ таас үктэллэрэ",
  "block.minecraft.mossy_cobblestone_wall": "Муохтаммыт күрбэ таас күрүө",
  "block.minecraft.mossy_stone_brick_slab": "Муохтаммыт күрбэ таас кирпииччэ билиитэтэ",
  "block.minecraft.mossy_stone_brick_stairs": "Муохтаммыт күрбэ таас кирпииччэ үктэллэрэ",
  "block.minecraft.mossy_stone_brick_wall": "Муохтаммыт күрбэ таас кирпииччэттэн күрүө",
  "block.minecraft.mossy_stone_bricks": "Муохтаммыт күрбэ таас кирпииччэ",
  "block.minecraft.moving_piston": "Хамсыыр сургуулук",
  "block.minecraft.mud": "Бадараан",
  "block.minecraft.mud_brick_slab": "Бадараан кирпииччэ билиитэтэ",
  "block.minecraft.mud_brick_stairs": "Бадараан кирпииччэ үктэллэрэ",
  "block.minecraft.mud_brick_wall": "Бадараан кирпииччэ күрүө",
  "block.minecraft.mud_bricks": "Бадараан кирпииччэлэр",
  "block.minecraft.muddy_mangrove_roots": "Мангра мас кирдээх силистэрэ",
  "block.minecraft.mushroom_stem": "Тэллэй атаҕа",
  "block.minecraft.mycelium": "Тэллэй силиһэ",
  "block.minecraft.nether_brick_fence": "Незер кирпииччэттэн күрүө",
  "block.minecraft.nether_brick_slab": "Незер кирпииччэ билиитэтэ",
  "block.minecraft.nether_brick_stairs": "Незер кирпииччэ үктэллэрэ",
  "block.minecraft.nether_brick_wall": "Незер кирпииччэттэн күрүө",
  "block.minecraft.nether_bricks": "Незер үктэллэрэ",
  "block.minecraft.nether_gold_ore": "Аллараа дойдутааҕы кыһыл көмус уруудата",
  "block.minecraft.nether_portal": "Незер аана",
  "block.minecraft.nether_quartz_ore": "Незер-кварц урууда",
  "block.minecraft.nether_sprouts": "Незер араскылара",
  "block.minecraft.nether_wart": "Незер үүнээйитэ",
  "block.minecraft.nether_wart_block": "Незер үүнэйитин булуога",
  "block.minecraft.netherite_block": "Незерит булуога",
  "block.minecraft.netherrack": "Незер тааһа",
  "block.minecraft.note_block": "Нуота булуога",
  "block.minecraft.oak_button": "Дууп кунуопка",
  "block.minecraft.oak_door": "Дууп аан",
  "block.minecraft.oak_fence": "Дууп күрүө",
  "block.minecraft.oak_fence_gate": "Дууп күрүө аана",
  "block.minecraft.oak_hanging_sign": "Дууп ыйанар бэлиэ",
  "block.minecraft.oak_leaves": "Дууп сэбирдэхтэрэ",
  "block.minecraft.oak_log": "Дууп бэрэбинэтэ",
  "block.minecraft.oak_planks": "Дууп хаптаһыннар",
  "block.minecraft.oak_pressure_plate": "Дууп тэпсиллэр билиитэтэ",
  "block.minecraft.oak_sapling": "Дууп талаҕа",
  "block.minecraft.oak_shelf": "Дууп долбуур",
  "block.minecraft.oak_sign": "Дууп бэлиэ",
  "block.minecraft.oak_slab": "Дууп билиитэтэ",
  "block.minecraft.oak_stairs": "Дууп үктэллэрэ",
  "block.minecraft.oak_trapdoor": "Дууп лүүк аан",
  "block.minecraft.oak_wall_hanging_sign": "Дууп истиэнэтээҕи бэлиэ",
  "block.minecraft.oak_wall_sign": "Дууп истиэнэтээҕи бэлиэ",
  "block.minecraft.oak_wood": "Дууп",
  "block.minecraft.observer": "Көрөөччү",
  "block.minecraft.obsidian": "Обсидиан",
  "block.minecraft.ochre_froglight": "Охра сандаарбаҕа",
  "block.minecraft.ominous_banner": "Кутталлаах былаах",
  "block.minecraft.open_eyeblossom": "Аһыллыбыт харах тыллыыта",
  "block.minecraft.orange_banner": "Чачархай былаах",
  "block.minecraft.orange_bed": "Чачархай орон",
  "block.minecraft.orange_candle": "Чачархай чүмэчи",
  "block.minecraft.orange_candle_cake": "Чачархай чүмэчилээх торт",
  "block.minecraft.orange_carpet": "Чачархай көбүөр",
  "block.minecraft.orange_concrete": "Чачархай бетон",
  "block.minecraft.orange_concrete_powder": "Чачархай бетон бороһуога",
  "block.minecraft.orange_glazed_terracotta": "Өстүөкэлэлэммит чачархай кэрээмикэ",
  "block.minecraft.orange_shulker_box": "Чачархай шалкер дьааһыга",
  "block.minecraft.orange_stained_glass": "Чачархай өстүөкүлэ",
  "block.minecraft.orange_stained_glass_pane": "Чачархай чараас өстүөкүлэ",
  "block.minecraft.orange_terracotta": "Чачархай кэрээмикэ",
  "block.minecraft.orange_tulip": "Чачархай түлпээн",
  "block.minecraft.orange_wool": "Чачархай түү",
  "block.minecraft.oxeye_daisy": "Ромашка",
  "block.minecraft.oxidized_chiseled_copper": "Аһыйбыт ойуттаҕас алтан",
  "block.minecraft.oxidized_copper": "Аһыйбыт алтан булуога",
  "block.minecraft.oxidized_copper_bars": "Аһыйбыт алтан талахтар",
  "block.minecraft.oxidized_copper_bulb": "Аһыйбыт алтан лаампата",
  "block.minecraft.oxidized_copper_chain": "Аһыйбыт алтан сыап",
  "block.minecraft.oxidized_copper_chest": "Аһыйбыт алтан сундуук",
  "block.minecraft.oxidized_copper_door": "Аһыйбыт алтан аана",
  "block.minecraft.oxidized_copper_golem_statue": "Аһыйбыт алтан голем статуйата",
  "block.minecraft.oxidized_copper_grate": "Аһыйбыт алтан хаххата",
  "block.minecraft.oxidized_copper_lantern": "Аһыйбыт алтан банаар",
  "block.minecraft.oxidized_copper_trapdoor": "Аһыйбыт алтан люга",
  "block.minecraft.oxidized_cut_copper": "Аһыйбыт алтан ойуттаҕас булуога",
  "block.minecraft.oxidized_cut_copper_slab": "Аһыйбыт алтан ойуттаҕас билиитэтэ",
  "block.minecraft.oxidized_cut_copper_stairs": "Аһыйбыт алтан ойуттаҕас үктэллэрэ",
  "block.minecraft.oxidized_lightning_rod": "Аһыйбыт этиҥи аһарааччы",
  "block.minecraft.packed_ice": "Кытаанах муус",
  "block.minecraft.packed_mud": "Кытаанах бадараан",
  "block.minecraft.pale_hanging_moss": "Намылайыыр кубархай муох",
  "block.minecraft.pale_moss_block": "Кубархай муох булуок",
  "block.minecraft.pale_moss_carpet": "Кубархай муох көбүөр",
  "block.minecraft.pale_oak_button": "Кубархай дууп кунуопка",
  "block.minecraft.pale_oak_door": "Кубархай дууп аан",
  "block.minecraft.pale_oak_fence": "Кубархай дууп күрүө",
  "block.minecraft.pale_oak_fence_gate": "Кубархай дууп күрүө аана",
  "block.minecraft.pale_oak_hanging_sign": "Кубархай дууп ыйанар бэлиэ",
  "block.minecraft.pale_oak_leaves": "Кубархай дууп сэбирдэхтэрэ",
  "block.minecraft.pale_oak_log": "Кубархай дууп бэрэбинэтэ",
  "block.minecraft.pale_oak_planks": "Кубархай дууп хаптаһыннар",
  "block.minecraft.pale_oak_pressure_plate": "Кубархай дууп тэпсиллэр билиитэтэ",
  "block.minecraft.pale_oak_sapling": "Кубархай дууп талаҕа",
  "block.minecraft.pale_oak_shelf": "Кубархай дууп долбуур",
  "block.minecraft.pale_oak_sign": "Кубархай дууп бэлиэ",
  "block.minecraft.pale_oak_slab": "Кубархай дууп билиитэтэ",
  "block.minecraft.pale_oak_stairs": "Кубархай дууп үктэллэрэ",
  "block.minecraft.pale_oak_trapdoor": "Кубархай дууп лүүк аан",
  "block.minecraft.pale_oak_wall_hanging_sign": "Кубархай дууп истиэнэҕэ ыйанар бэлиэ",
  "block.minecraft.pale_oak_wall_sign": "Кубархай дууп истиэнэ бэлиэтэ",
  "block.minecraft.pale_oak_wood": "Кубархай дууп маһа",
  "block.minecraft.pearlescent_froglight": "Чөмчүүк сандаарбаҕа",
  "block.minecraft.peony": "Пион",
  "block.minecraft.petrified_oak_slab": "Таастытыйбыт дууп билиитэтэ",
  "block.minecraft.piglin_head": "Пиглин төбөтө",
  "block.minecraft.piglin_wall_head": "Пиглин истиэнэтээҕи төбөтө",
  "block.minecraft.pink_banner": "Оруосабай былаах",
  "block.minecraft.pink_bed": "Оруосабай орон",
  "block.minecraft.pink_candle": "Оруосабай чүмэчи",
  "block.minecraft.pink_candle_cake": "Оруосабай чүмэчилээх торт",
  "block.minecraft.pink_carpet": "Оруосабай көбүөр",
  "block.minecraft.pink_concrete": "Оруосабай бетон",
  "block.minecraft.pink_concrete_powder": "Оруосабай бетон бороһуока",
  "block.minecraft.pink_glazed_terracotta": "Өстүөкэлэлэммит оруосабай кэрээмикэ",
  "block.minecraft.pink_petals": "Оруосабай сэбирдэхтэр",
  "block.minecraft.pink_shulker_box": "Оруосабай шалкер дьааһыга",
  "block.minecraft.pink_stained_glass": "Оруосабай өстүөкүлэ",
  "block.minecraft.pink_stained_glass_pane": "Оруосабай чараас өстүөкүлэ",
  "block.minecraft.pink_terracotta": "Оруосабай кэрээмикэ",
  "block.minecraft.pink_tulip": "Оруосабай түлпээн",
  "block.minecraft.pink_wool": "Оруосабай түү",
  "block.minecraft.piston": "Сургуулук",
  "block.minecraft.piston_head": "Сургуулук төбөтө",
  "block.minecraft.pitcher_crop": "Купсуун үүнүүтэ",
  "block.minecraft.pitcher_plant": "Купсуун үүнээйи",
  "block.minecraft.player_head": "Оонньооччу төбөтө",
  "block.minecraft.player_head.named": "%s төбөтө",
  "block.minecraft.player_wall_head": "Оонньооччу истиэнэтээҕи төбөтө",
  "block.minecraft.podzol": "Күллүк",
  "block.minecraft.pointed_dripstone": "Таммаламмыт таас",
  "block.minecraft.polished_andesite": "Аалыллыбыт андыһыыт",
  "block.minecraft.polished_andesite_slab": "Аалыллыбыт андыһыыт билиитэтэ",
  "block.minecraft.polished_andesite_stairs": "Аалыллыбыт андыһыыт үктэллэрэ",
  "block.minecraft.polished_basalt": "Аалыллыбыт базальт",
  "block.minecraft.polished_blackstone": "Аалыллыбыт хара таас",
  "block.minecraft.polished_blackstone_brick_slab": "Аалыллыбыт хара таас кирпииччэ билиитэтэ",
  "block.minecraft.polished_blackstone_brick_stairs": "Аалыллыбыт хара таас кирпииччэ үктэллэрэ",
  "block.minecraft.polished_blackstone_brick_wall": "Аалыллыбыт хара таас кирпииччэ күрүөтэ",
  "block.minecraft.polished_blackstone_bricks": "Аалыллыбыт хара таас кирпииччэлэр",
  "block.minecraft.polished_blackstone_button": "Аалыллыбыт хара таас кунуопка",
  "block.minecraft.polished_blackstone_pressure_plate": "Аалыллыбыт хара таас кирпииччэ баттанар билиитэтэ",
  "block.minecraft.polished_blackstone_slab": "Аалыллыбыт хара таас Билиитэтэ",
  "block.minecraft.polished_blackstone_stairs": "Аалыллыбыт хара таас Кирилиэһэ",
  "block.minecraft.polished_blackstone_wall": "Аалыллыбыт хара таас күрүөтэ",
  "block.minecraft.polished_deepslate": "Аалыллыбыт дириҥнээҕи таас",
  "block.minecraft.polished_deepslate_slab": "Аалыллыбыт дириҥнээҕи таас билиитэтэ",
  "block.minecraft.polished_deepslate_stairs": "Аалыллыбыт дириҥнээҕи таас үктэллэр",
  "block.minecraft.polished_deepslate_wall": "Аалыллыбыт дириҥнээҕи таас күрүө",
  "block.minecraft.polished_diorite": "Аалыллыбыт диэриит",
  "block.minecraft.polished_diorite_slab": "Аалыллыбыт диэриит билиитэтэ",
  "block.minecraft.polished_diorite_stairs": "Аалыллыбыт диэриит үктэллэрэ",
  "block.minecraft.polished_granite": "Аалыллыбыт кыраньыыт",
  "block.minecraft.polished_granite_slab": "Аалыллыбыт кыраньыыт билиитэтэ",
  "block.minecraft.polished_granite_stairs": "Аалыллыбыт кыраньыыт үктэллэрэ",
  "block.minecraft.polished_tuff": "Полированнай тууф",
  "block.minecraft.polished_tuff_slab": "Полированнай тууф билиитэ",
  "block.minecraft.polished_tuff_stairs": "Полированнай тууфтан үктэл",
  "block.minecraft.polished_tuff_wall": "Полированнай тууфтан истиэнэ",
  "block.minecraft.poppy": "Маак",
  "block.minecraft.potatoes": "Хортуоска",
  "block.minecraft.potted_acacia_sapling": "Иһиттээх акаассыйа талаҕа",
  "block.minecraft.potted_allium": "Иһиттээх батун луук",
  "block.minecraft.potted_azalea_bush": "Иһиттээх азалия",
  "block.minecraft.potted_azure_bluet": "Иһиттээх бороҥ хаустония",
  "block.minecraft.potted_bamboo": "Иһиттээх бамбук",
  "block.minecraft.potted_birch_sapling": "Иһиттээх хатыҥ талаҕа",
  "block.minecraft.potted_blue_orchid": "Иһиттээх күөх архыдыайа",
  "block.minecraft.potted_brown_mushroom": "Иһиттээх бороҥ тэллэй",
  "block.minecraft.potted_cactus": "Иһиттээх кактус",
  "block.minecraft.potted_cherry_sapling": "Иһиттээх вишня талаҕа",
  "block.minecraft.potted_closed_eyeblossom": "Күөстээх сабыллыбыт харах тылллыыта",
  "block.minecraft.potted_cornflower": "Иһиттээх күөх сибэкки",
  "block.minecraft.potted_crimson_fungus": "Иһиттээх өһөх өҥнөөх тэллэй",
  "block.minecraft.potted_crimson_roots": "Иһиттээх өһөх өҥнөөх силистэр",
  "block.minecraft.potted_dandelion": "Иһиттээх алтан төбө",
  "block.minecraft.potted_dark_oak_sapling": "Иһиттээх хара дууп талаҕа",
  "block.minecraft.potted_dead_bush": "Иһиттээх өлбүт ыарҕа",
  "block.minecraft.potted_fern": "Иһиттээх таас от",
  "block.minecraft.potted_flowering_azalea_bush": "Иһиттээх сибэккилэммит азалия",
  "block.minecraft.potted_golden_dandelion": "Иһиттээх кыһыл көмүс ньээм",
  "block.minecraft.potted_jungle_sapling": "Иһиттээх соҕурууҥу мас талаҕа",
  "block.minecraft.potted_lily_of_the_valley": "Иһиттээх лаандыс",
  "block.minecraft.potted_mangrove_propagule": "Иһиттээх мангра үүнээйитэ",
  "block.minecraft.potted_oak_sapling": "Иһиттээх хара дууп талаҕа",
  "block.minecraft.potted_open_eyeblossom": "Күөстээх аһыллыбыт харах тылллыыта",
  "block.minecraft.potted_orange_tulip": "Иһиттээх чачархай түлпээн",
  "block.minecraft.potted_oxeye_daisy": "Иһиттээх ромашка",
  "block.minecraft.potted_pale_oak_sapling": "Иһиттээх кубархай дууп талаҕа",
  "block.minecraft.potted_pink_tulip": "Иһиттээх оруосабай түлпээн",
  "block.minecraft.potted_poppy": "Иһиттээх маак",
  "block.minecraft.potted_red_mushroom": "Иһиттээх кыһыл тэллэй",
  "block.minecraft.potted_red_tulip": "Иһиттээх кыһыл түлпээн",
  "block.minecraft.potted_spruce_sapling": "Иһиттээх харыйа талаҕа",
  "block.minecraft.potted_torchflower": "Иһиттээх уотунньук",
  "block.minecraft.potted_warped_fungus": "Иһиттээх бутуллубут тэллэй",
  "block.minecraft.potted_warped_roots": "Иһиттээх бутуллубут силистэр",
  "block.minecraft.potted_white_tulip": "Иһиттээх маҕан түлпээн",
  "block.minecraft.potted_wither_rose": "Иһиттээх Визер оруосата",
  "block.minecraft.powder_snow": "Көбдөркөй хаар",
  "block.minecraft.powder_snow_cauldron": "Көбдөркөй хаардаах солуур",
  "block.minecraft.powered_rail": "Уоттаах тимир суол",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Призмарин кирпииччэ билиитэтэ",
  "block.minecraft.prismarine_brick_stairs": "Призмарин кирпииччэ үктэллэрэ",
  "block.minecraft.prismarine_bricks": "Призмарин кирпииччэ",
  "block.minecraft.prismarine_slab": "Призмарин билиитэтэ",
  "block.minecraft.prismarine_stairs": "Призмарин үктэллэрэ",
  "block.minecraft.prismarine_wall": "Призмарин күрүө",
  "block.minecraft.pumpkin": "Тыыкыба",
  "block.minecraft.pumpkin_stem": "Тыыкыба умнаһа",
  "block.minecraft.purple_banner": "Хара саарыл былаах",
  "block.minecraft.purple_bed": "Хара саарыл орон",
  "block.minecraft.purple_candle": "Хара саарыл чүмэчи",
  "block.minecraft.purple_candle_cake": "Хара саарыл чүмэчилээх торт",
  "block.minecraft.purple_carpet": "Хара саарыл көбүөр",
  "block.minecraft.purple_concrete": "Хара саарыл бетон",
  "block.minecraft.purple_concrete_powder": "Хара саарыл бетон бороһуога",
  "block.minecraft.purple_glazed_terracotta": "Өстүөкэлэлэммит хара саарыл кэрээмикэ",
  "block.minecraft.purple_shulker_box": "Хара саарыл шалкер дьааһыга",
  "block.minecraft.purple_stained_glass": "Хара саарыл өстүөкүлэ",
  "block.minecraft.purple_stained_glass_pane": "Хара саарыл чараас өстүөкүлэ",
  "block.minecraft.purple_terracotta": "Хара саарыл кэрээмикэ",
  "block.minecraft.purple_wool": "Хара саарыл түү",
  "block.minecraft.purpur_block": "Пурпур булуога",
  "block.minecraft.purpur_pillar": "Пурпур колонната",
  "block.minecraft.purpur_slab": "Пурпур билиитэтэ",
  "block.minecraft.purpur_stairs": "Пурпур үктэллэрэ",
  "block.minecraft.quartz_block": "Кварц булуога",
  "block.minecraft.quartz_bricks": "Кварц кирпииччэлэр",
  "block.minecraft.quartz_pillar": "Кварц баҕана",
  "block.minecraft.quartz_slab": "Кварц билиитэтэ",
  "block.minecraft.quartz_stairs": "Кварц үктэллэрэ",
  "block.minecraft.rail": "Тимир суол",
  "block.minecraft.raw_copper_block": "Сиикэй алтан булуога",
  "block.minecraft.raw_gold_block": "Сиикэй көмүс булуога",
  "block.minecraft.raw_iron_block": "Сиикэй тимир булуога",
  "block.minecraft.red_banner": "Кыһыл былаах",
  "block.minecraft.red_bed": "Кыһыл орон",
  "block.minecraft.red_candle": "Кыһыл чүмэчи",
  "block.minecraft.red_candle_cake": "Кыһыл чүмэчилээх торт",
  "block.minecraft.red_carpet": "Кыһыл көбүөр",
  "block.minecraft.red_concrete": "Кыһыл бетон",
  "block.minecraft.red_concrete_powder": "Кыһыл бетон бороһуога",
  "block.minecraft.red_glazed_terracotta": "Өстүөкэлэлэммит кыһыл кэрээмикэ",
  "block.minecraft.red_mushroom": "Кыһыл тэллэй",
  "block.minecraft.red_mushroom_block": "Кыһыл тэллэй булуога",
  "block.minecraft.red_nether_brick_slab": "Незер кыһыл кирпииччэ билиитэтэ",
  "block.minecraft.red_nether_brick_stairs": "Незер кыһыл кирпииччэ үктэллэрэ",
  "block.minecraft.red_nether_brick_wall": "Незер кыһыл кирпииччэттэн күрүө",
  "block.minecraft.red_nether_bricks": "Незер кыһыл кирпииччэлэрэ",
  "block.minecraft.red_sand": "Кыһыл Кумах",
  "block.minecraft.red_sandstone": "Кыһыл кумах таас",
  "block.minecraft.red_sandstone_slab": "Кыһыл кумах таас билиитэтэ",
  "block.minecraft.red_sandstone_stairs": "Кыһыл кумах таас үктэллэрэ",
  "block.minecraft.red_sandstone_wall": "Кыһыл кумах таас күрүө",
  "block.minecraft.red_shulker_box": "Кыһыл шалкер дьааһыга",
  "block.minecraft.red_stained_glass": "Кыһыл өстүөкүлэ",
  "block.minecraft.red_stained_glass_pane": "Кыһыл чараас өстүөкүлэ",
  "block.minecraft.red_terracotta": "Кыһыл кэрээмикэ",
  "block.minecraft.red_tulip": "Кыһыл түлпээн",
  "block.minecraft.red_wool": "Кыһыл түү",
  "block.minecraft.redstone_block": "Редстоун булуога",
  "block.minecraft.redstone_lamp": "Редстоун лаампа",
  "block.minecraft.redstone_ore": "Редстоун урууда",
  "block.minecraft.redstone_torch": "Редстоун факел",
  "block.minecraft.redstone_wall_torch": "Редстоун истиэнэ факела",
  "block.minecraft.redstone_wire": "Редстоун буруобата",
  "block.minecraft.reinforced_deepslate": "Күүһүрүллүбүт дириҥнээҕи таас",
  "block.minecraft.repeater": "Редстоун хатылааччы",
  "block.minecraft.repeating_command_block": "Хатыланар хамаандалар булуоктара",
  "block.minecraft.resin_block": "Сымала булуога",
  "block.minecraft.resin_brick_slab": "Сымала кирпииччэ билиитэ",
  "block.minecraft.resin_brick_stairs": "Сымала кирпииччэ үктэл",
  "block.minecraft.resin_brick_wall": "Сымала кирпииччэ күрүө",
  "block.minecraft.resin_bricks": "Сымала кирпииччэлэр",
  "block.minecraft.resin_clump": "Сымала хомоҕо",
  "block.minecraft.respawn_anchor": "Тиллии дьаакыра",
  "block.minecraft.rooted_dirt": "Силистээх буор",
  "block.minecraft.rose_bush": "Оруосабай сэппэрээк",
  "block.minecraft.sand": "Кумах",
  "block.minecraft.sandstone": "Кумах таас",
  "block.minecraft.sandstone_slab": "Кумах таас билиитэтэ",
  "block.minecraft.sandstone_stairs": "Кумах таас үктэллэрэ",
  "block.minecraft.sandstone_wall": "Кумах таас күрүө",
  "block.minecraft.scaffolding": "Оскуонньа",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалк катализатора",
  "block.minecraft.sculk_sensor": "Скалк сенсор",
  "block.minecraft.sculk_shrieker": "Скалк хаһытааччыта",
  "block.minecraft.sculk_vein": "Скалк тымыра",
  "block.minecraft.sea_lantern": "Байҕал лаампата",
  "block.minecraft.sea_pickle": "Байҕал оҕурсуута",
  "block.minecraft.seagrass": "Байҕал ото",
  "block.minecraft.set_spawn": "Хат тиллэр сир ананна",
  "block.minecraft.short_dry_grass": "Кураанах намыһах от",
  "block.minecraft.short_grass": "Намыһах от",
  "block.minecraft.shroomlight": "Сырдык-тэллэй",
  "block.minecraft.shulker_box": "Шалкер дьааһыга",
  "block.minecraft.skeleton_skull": "Дьардьама бас уҥуоҕа",
  "block.minecraft.skeleton_wall_skull": "Дьардьама истиэнэтээҕи бас уҥуоҕа",
  "block.minecraft.slime_block": "Салыҥ булуога",
  "block.minecraft.small_amethyst_bud": "Кыра аметист үөскэҕэ",
  "block.minecraft.small_dripleaf": "Кыра тамма-сэбирдэх",
  "block.minecraft.smithing_table": "Тимир ууһун остуола",
  "block.minecraft.smoker": "Ыыһыырдар масыына",
  "block.minecraft.smooth_basalt": "Аалыллыбыт базальт",
  "block.minecraft.smooth_quartz": "Аалыллыбыт кварц булуога",
  "block.minecraft.smooth_quartz_slab": "Аалыллыбыт кварц билиитэтэ",
  "block.minecraft.smooth_quartz_stairs": "Аалыллыбыт кварц үктэллэрэ",
  "block.minecraft.smooth_red_sandstone": "Аалыллыбыт кыһыл кумах таас",
  "block.minecraft.smooth_red_sandstone_slab": "Аалыллыбыт кыһыл кумах таас билиитэтэ",
  "block.minecraft.smooth_red_sandstone_stairs": "Аалыллыбыт кыһыл кумах таас үктэллэрэ",
  "block.minecraft.smooth_sandstone": "Аалыллыбыт кумах таас",
  "block.minecraft.smooth_sandstone_slab": "Аалыллыбыт кумах таас билиитэтэ",
  "block.minecraft.smooth_sandstone_stairs": "Аалыллыбыт кумах таас үктэллэрэ",
  "block.minecraft.smooth_stone": "Аалыллыбыт таас",
  "block.minecraft.smooth_stone_slab": "Аалыллыбыт таас билиитэтэ",
  "block.minecraft.sniffer_egg": "Сытырҕас сымыыта",
  "block.minecraft.snow": "Хаар",
  "block.minecraft.snow_block": "Хаар булуога",
  "block.minecraft.soul_campfire": "Дууһа оттуллубут уота",
  "block.minecraft.soul_fire": "Дууһа уота",
  "block.minecraft.soul_lantern": "Дууһа лаампата",
  "block.minecraft.soul_sand": "Дууһа кумаҕа",
  "block.minecraft.soul_soil": "Дууһа буора",
  "block.minecraft.soul_torch": "Дууһа факела",
  "block.minecraft.soul_wall_torch": "Истиэнэтээҕи дууһа факела",
  "block.minecraft.spawn.not_valid": "Дьиэтээҕи орон эбэтэр иитиллибит тилиннэрэр дьаакырыҥ суох эбэтэр бүөлэнэн хаалбыт",
  "block.minecraft.spawner": "Абаһыылар төрөтөрдөрө",
  "block.minecraft.spawner.desc1": "Төрөтөр сымыыты кытары дьайсыы:",
  "block.minecraft.spawner.desc2": "Моб көрүҥүн быһаарар",
  "block.minecraft.sponge": "Губка",
  "block.minecraft.spore_blossom": "Спора чэчигэ",
  "block.minecraft.spruce_button": "Харыйа кунуопка",
  "block.minecraft.spruce_door": "Харыйа аан",
  "block.minecraft.spruce_fence": "Харыйа күрүө",
  "block.minecraft.spruce_fence_gate": "Харыйа күрүө аана",
  "block.minecraft.spruce_hanging_sign": "Харыйа ыйанар бэлиэ",
  "block.minecraft.spruce_leaves": "Харыйа сэбирдэхтэрэ",
  "block.minecraft.spruce_log": "Харыйа бэрэбинэтэ",
  "block.minecraft.spruce_planks": "Харыйа хаптаһыннар",
  "block.minecraft.spruce_pressure_plate": "Харыйа тэпсиллэр билиитэтэ",
  "block.minecraft.spruce_sapling": "Харыйа талаҕа",
  "block.minecraft.spruce_shelf": "Харыйа долбуур",
  "block.minecraft.spruce_sign": "Харыйа бэлиэ",
  "block.minecraft.spruce_slab": "Харыйа билиитэтэ",
  "block.minecraft.spruce_stairs": "Харыйа үктэллэрэ",
  "block.minecraft.spruce_trapdoor": "Харыйа лүүк аан",
  "block.minecraft.spruce_wall_hanging_sign": "Харыйа истиэнэтээҕи бэлиэ",
  "block.minecraft.spruce_wall_sign": "Харыйа истиэнэтээҕи бэлиэ",
  "block.minecraft.spruce_wood": "Харыйа",
  "block.minecraft.sticky_piston": "Сыстыгынас сургуулук",
  "block.minecraft.stone": "Таас",
  "block.minecraft.stone_brick_slab": "Таас кирпииччэ билиитэтэ",
  "block.minecraft.stone_brick_stairs": "Таас кирпииччэ үктэллэрэ",
  "block.minecraft.stone_brick_wall": "Таас кирпииччэ күрүө",
  "block.minecraft.stone_bricks": "Таас кирпииччэ",
  "block.minecraft.stone_button": "Таас кунуопка",
  "block.minecraft.stone_pressure_plate": "Таас тэпсиллэр билиитэтэ",
  "block.minecraft.stone_slab": "Таас билиитэтэ",
  "block.minecraft.stone_stairs": "Таас үктэллэрэ",
  "block.minecraft.stonecutter": "Тааһы быһар тэрил",
  "block.minecraft.stripped_acacia_log": "Суоруллубут акаассыйа бэрэбинэтэ",
  "block.minecraft.stripped_acacia_wood": "Суоруллубут акаассыйа",
  "block.minecraft.stripped_bamboo_block": "Суоруллубут бамбук булуога",
  "block.minecraft.stripped_birch_log": "Суоруллубут хатыҥ бэрэбинэтэ",
  "block.minecraft.stripped_birch_wood": "Суоруллубут хатыҥ",
  "block.minecraft.stripped_cherry_log": "Суоруллубут вишня маһын бэрэбинэтэ",
  "block.minecraft.stripped_cherry_wood": "Суоруллубут вишня маһа",
  "block.minecraft.stripped_crimson_hyphae": "Ыраастаныллыбыт өһөх өҥнөөх тэллэй силистэрэ",
  "block.minecraft.stripped_crimson_stem": "Ыраастаныллыбыт өһөх өҥнөөх умнас",
  "block.minecraft.stripped_dark_oak_log": "Суоруллубут хара дууп бэрэбинэтэ",
  "block.minecraft.stripped_dark_oak_wood": "Суоруллубут хара дууп",
  "block.minecraft.stripped_jungle_log": "Суоруллубут соҕурууҥу мас бэрэбинэтэ",
  "block.minecraft.stripped_jungle_wood": "Суоруллубут соҕурууҥу мас",
  "block.minecraft.stripped_mangrove_log": "Суоруллубут мангра мас бэрэбинэтэ",
  "block.minecraft.stripped_mangrove_wood": "Суоруллубут мангра мас",
  "block.minecraft.stripped_oak_log": "Суоруллубут дууп бэрэбинэтэ",
  "block.minecraft.stripped_oak_wood": "Суоруллубут дууп",
  "block.minecraft.stripped_pale_oak_log": "Суоруллубут кубархай дууп бэрэбинэтэ",
  "block.minecraft.stripped_pale_oak_wood": "Суоруллубут кубархай дууп маһа",
  "block.minecraft.stripped_spruce_log": "Суоруллубут харыйа бэрэбинэтэ",
  "block.minecraft.stripped_spruce_wood": "Суоруллубут харыйа",
  "block.minecraft.stripped_warped_hyphae": "Ыраастаныллыбыт бутуллубут тэллэй силистэрэ",
  "block.minecraft.stripped_warped_stem": "Ыраастаныллыбыт бутуллубут умнас",
  "block.minecraft.structure_block": "Тутуу булуога",
  "block.minecraft.structure_void": "Кураанах булуок",
  "block.minecraft.sugar_cane": "Саахар хомуһа",
  "block.minecraft.sunflower": "Күн сибэккитэ",
  "block.minecraft.suspicious_gravel": "Дьикти көрүҥнээх чай таас",
  "block.minecraft.suspicious_sand": "Дьикти көрүҥнээх кумах",
  "block.minecraft.sweet_berry_bush": "Минньигэс отон ыарҕата",
  "block.minecraft.tall_dry_grass": "Кураанах уһун от",
  "block.minecraft.tall_grass": "Уһун от",
  "block.minecraft.tall_seagrass": "Уһун байҕал ото",
  "block.minecraft.target": "Сыал",
  "block.minecraft.terracotta": "Кэрээмикэ",
  "block.minecraft.test_block": "Тест булуок",
  "block.minecraft.test_instance_block": "Тест булуок экземпляра",
  "block.minecraft.tinted_glass": "Хараҥатыллыбыт өстүөкүлэ",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT эстиитэ арахсыбыт",
  "block.minecraft.torch": "Факел",
  "block.minecraft.torchflower": "Уотунньук",
  "block.minecraft.torchflower_crop": "Уотунньук уга",
  "block.minecraft.trapped_chest": "Угаайылаах дьааһык",
  "block.minecraft.trial_spawner": "Тургутуу төрөрөтөрдөрө",
  "block.minecraft.tripwire": "Тардыы",
  "block.minecraft.tripwire_hook": "Тордуох",
  "block.minecraft.tube_coral": "Турба коралл",
  "block.minecraft.tube_coral_block": "Турба коралл булуога",
  "block.minecraft.tube_coral_fan": "Дэйбиир турба коралл",
  "block.minecraft.tube_coral_wall_fan": "Турба коралл көнө дэйбиирэ",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Тууф кирпииччэтэн билиитэ",
  "block.minecraft.tuff_brick_stairs": "Тууф кирипииччэтэн үктэл",
  "block.minecraft.tuff_brick_wall": "Тууф кирпииччэ истиэнэ",
  "block.minecraft.tuff_bricks": "Тууф кирпииччэлэр",
  "block.minecraft.tuff_slab": "Тууф билиитэ",
  "block.minecraft.tuff_stairs": "Тууф үктэл",
  "block.minecraft.tuff_wall": "Тууф истиэнэ",
  "block.minecraft.turtle_egg": "Черепаха сымыыта",
  "block.minecraft.twisting_vines": "Эриллэр лабаа",
  "block.minecraft.twisting_vines_plant": "Эриллэр лабаа умнаһа",
  "block.minecraft.vault": "Хомуур",
  "block.minecraft.verdant_froglight": "Малахит сандаарбаҕа",
  "block.minecraft.vine": "Лианалар",
  "block.minecraft.void_air": "Вакуум",
  "block.minecraft.wall_torch": "Истиэнэ факела",
  "block.minecraft.warped_button": "Бутуллубут мас кунуопка",
  "block.minecraft.warped_door": "Бутуллубут мас аан",
  "block.minecraft.warped_fence": "Бутуллубут мас күрүөтэ",
  "block.minecraft.warped_fence_gate": "Бутуллубут мас күрүөтүн аана",
  "block.minecraft.warped_fungus": "Бутуллубут тэллэй",
  "block.minecraft.warped_hanging_sign": "Бутуллубут мас бэлиэ",
  "block.minecraft.warped_hyphae": "Бутуллубут тэллэй силистэрэ",
  "block.minecraft.warped_nylium": "Бутуллубут ниилий",
  "block.minecraft.warped_planks": "Бутуллубут хаптаһын",
  "block.minecraft.warped_pressure_plate": "Бутуллубут мас тэпсиллэр билиитэтэ",
  "block.minecraft.warped_roots": "Бутуллубут Силистэр",
  "block.minecraft.warped_shelf": "Бутуллубут долбуур",
  "block.minecraft.warped_sign": "Бутуллубут мас бэлиэтэ",
  "block.minecraft.warped_slab": "Бутуллубут мас билиитэтэ",
  "block.minecraft.warped_stairs": "Бутуллубут мас кирилиэһэ",
  "block.minecraft.warped_stem": "Бутуллубут умнас",
  "block.minecraft.warped_trapdoor": "Бутуллубут мас лүүк аана",
  "block.minecraft.warped_wall_hanging_sign": "Бутуллубут мас истиэнэтээҕи бэлиэ",
  "block.minecraft.warped_wall_sign": "Бутуллубут мас истиэнэтээҕи бэлиэ",
  "block.minecraft.warped_wart_block": "Бутуллубут үүнээйи булуога",
  "block.minecraft.water": "Уу",
  "block.minecraft.water_cauldron": "Уулаах солуур",
  "block.minecraft.waxed_chiseled_copper": "Буоскаламмыт алтан ойуттаҕас булуога",
  "block.minecraft.waxed_copper_bars": "Буоскаламмыт алтан талахтар",
  "block.minecraft.waxed_copper_block": "Буоскаламмыт алтан булуога",
  "block.minecraft.waxed_copper_bulb": "Буоскаламмыт алтан лаампата",
  "block.minecraft.waxed_copper_chain": "Буоскаламмыт алтан сыап",
  "block.minecraft.waxed_copper_chest": "Буоскаламмыт алтан сундуук",
  "block.minecraft.waxed_copper_door": "Буоскаламмыт алтан аана",
  "block.minecraft.waxed_copper_golem_statue": "Буоскаламмыт алтан голем статуйата",
  "block.minecraft.waxed_copper_grate": "Буоскаламмыт алтан хаххата",
  "block.minecraft.waxed_copper_lantern": "Буоскаламмыт алтан банаар",
  "block.minecraft.waxed_copper_trapdoor": "Буоскаламмыт алтан люга",
  "block.minecraft.waxed_cut_copper": "Ойуттаҕас буоскаламмыт алтан булуога",
  "block.minecraft.waxed_cut_copper_slab": "Буоскаламмыт алтан ойуттаҕас билиитэтэ",
  "block.minecraft.waxed_cut_copper_stairs": "Буоскаламмыт алтан үктэллэрэ",
  "block.minecraft.waxed_exposed_chiseled_copper": "Буоскаламмыт хараарбыт ойуттаҕас алтан",
  "block.minecraft.waxed_exposed_copper": "Хараарбыт буоскаламмыт алтан булуога",
  "block.minecraft.waxed_exposed_copper_bars": "Хараарбыт буоскаламмыт алтан талахтар",
  "block.minecraft.waxed_exposed_copper_bulb": "Хараарбыт буоскаламмыт алтан лаампа",
  "block.minecraft.waxed_exposed_copper_chain": "Хараарбыт буоскаламмыт алтан сыап",
  "block.minecraft.waxed_exposed_copper_chest": "Хараарбыт буоскаламмыт алтан сундуук",
  "block.minecraft.waxed_exposed_copper_door": "Хараарбыт буоскаламмыт алтан аан",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Хараарбыт буоскаламмыт голем статуйата",
  "block.minecraft.waxed_exposed_copper_grate": "Хараарбыт буоскаламмыт алтан эрэһээҥки",
  "block.minecraft.waxed_exposed_copper_lantern": "Хараарбыт буоскаламмыт алтан банаар",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Хараарбыт буоскаламмыт алтан лүүк",
  "block.minecraft.waxed_exposed_cut_copper": "Хараарбыт буоскаламмыт алтан ойуттаҕас булуога",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Хараарбыт буоскаламмыт алтан ойуттаҕас билиитэтэ",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Хараарбыт буоскаламмыт алтан ойуттаҕас үктэллэрэ",
  "block.minecraft.waxed_exposed_lightning_rod": "Хараарбыт буоскаламмыт этиҥи аһарааччы",
  "block.minecraft.waxed_lightning_rod": "Буоскаламмыт этиҥи аһарааччы",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Буоскаламмыт аһыйбыт ойуттаҕас алтан",
  "block.minecraft.waxed_oxidized_copper": "Аһыйбыт буоскаламмыт алтан булуога",
  "block.minecraft.waxed_oxidized_copper_bars": "Буоскаламмыт аһыйбыт алтан талахтар",
  "block.minecraft.waxed_oxidized_copper_bulb": "Буоскаламмыт аһыйбыт алтан лаампа",
  "block.minecraft.waxed_oxidized_copper_chain": "Буоскаламмыт аһыйбыт алтан сыап",
  "block.minecraft.waxed_oxidized_copper_chest": "Буоскаламмыт аһыйбыт алтан сундуук",
  "block.minecraft.waxed_oxidized_copper_door": "Буоскаламмыт аһыйбыт алтан аан",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Буоскаламмыт аһыйбыт голем статуйата",
  "block.minecraft.waxed_oxidized_copper_grate": "Буоскаламмыт аһыйбыт алтан эрэһээҥки",
  "block.minecraft.waxed_oxidized_copper_lantern": "Буоскаламмыт аһыйбыт алтан банаар",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Буоскаламмыт аһыйбыт алтан лүүк",
  "block.minecraft.waxed_oxidized_cut_copper": "Аһыйбыт буоскаламмыт алтан ойуттаҕас булуога",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Аһыйбыт буоскаламмыт алтан ойуттаҕас билиитэтэ",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Аһыйбыт буспут алтан ойуттаҕас үктэллэрэ",
  "block.minecraft.waxed_oxidized_lightning_rod": "Буоскаламмыт аһыйбыт этиҥи аһарааччы",
  "block.minecraft.waxed_weathered_chiseled_copper": "Буоскаламмыт куурбут ойуттаҕас алтан",
  "block.minecraft.waxed_weathered_copper": "Эргэрбит буоскаламмыт алтан булуога",
  "block.minecraft.waxed_weathered_copper_bars": "Эргэрбит буоскаламмыт алтан талахтар",
  "block.minecraft.waxed_weathered_copper_bulb": "Эргэрбит буоскаламмыт алтан лаампа",
  "block.minecraft.waxed_weathered_copper_chain": "Эргэрбит буоскаламмыт алтан сыап",
  "block.minecraft.waxed_weathered_copper_chest": "Эргэрбит буоскаламмыт алтан сундуук",
  "block.minecraft.waxed_weathered_copper_door": "Эргэрбит буоскаламмыт алтан аан",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Эргэрбит буоскаламмыт голем статуйата",
  "block.minecraft.waxed_weathered_copper_grate": "Эргэрбит буоскаламмыт алтан эрэһээҥки",
  "block.minecraft.waxed_weathered_copper_lantern": "Эргэрбит буоскаламмыт алтан банаар",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Эргэрбит буоскаламмыт алтан лүүк",
  "block.minecraft.waxed_weathered_cut_copper": "Эргэрбит буоскаламмыт алтан ойуттаҕас булуога",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Эргэрбит буоскаламмыт алтан ойуттаҕас билиитэтэ",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Эргэрбит буоскаламмыт алтан ойуттаҕас үктэллэрэ",
  "block.minecraft.waxed_weathered_lightning_rod": "Эргэрбит буоскаламмыт этиҥи аһарааччы",
  "block.minecraft.weathered_chiseled_copper": "Куурбут ойуттаҕас алтан",
  "block.minecraft.weathered_copper": "Эргэрбит алтан булуога",
  "block.minecraft.weathered_copper_bars": "Эргэрбит алтан талахтар",
  "block.minecraft.weathered_copper_bulb": "Эргэрбит алтан лаампа",
  "block.minecraft.weathered_copper_chain": "Эргэрбит алтан сыап",
  "block.minecraft.weathered_copper_chest": "Эргэрбит алтан сундуук",
  "block.minecraft.weathered_copper_door": "Эргэрбит алтан аан",
  "block.minecraft.weathered_copper_golem_statue": "Эргэрбит голем статуйата",
  "block.minecraft.weathered_copper_grate": "Эргэрбит алтан эрэһээҥки",
  "block.minecraft.weathered_copper_lantern": "Эргэрбит алтан банаар",
  "block.minecraft.weathered_copper_trapdoor": "Эргэрбит алтан лүүк",
  "block.minecraft.weathered_cut_copper": "Эргэрбит алтан ойуттаҕас булуога",
  "block.minecraft.weathered_cut_copper_slab": "Эргэрбит алтан ойуттаҕас билиитэтэ",
  "block.minecraft.weathered_cut_copper_stairs": "Эргэрбит ойуттаҕас алтан үктэллэр",
  "block.minecraft.weathered_lightning_rod": "Эргэрбит этиҥи аһарааччы",
  "block.minecraft.weeping_vines": "Ытамньыйар лабаа",
  "block.minecraft.weeping_vines_plant": "Ытамньыйар лабаа умнаһа",
  "block.minecraft.wet_sponge": "Инчэҕэй губка",
  "block.minecraft.wheat": "Сэлиэһинэй араскыта",
  "block.minecraft.white_banner": "Маҥан былаах",
  "block.minecraft.white_bed": "Маҥан орон",
  "block.minecraft.white_candle": "Маҕан чүмэчи",
  "block.minecraft.white_candle_cake": "Маҕан чүмэчилээх торт",
  "block.minecraft.white_carpet": "Маҕан көбүөр",
  "block.minecraft.white_concrete": "Маҕан бетон",
  "block.minecraft.white_concrete_powder": "Маҕан бетон бороһуога",
  "block.minecraft.white_glazed_terracotta": "Өстүөкэлэлэммит маҕан кэрээмикэ",
  "block.minecraft.white_shulker_box": "Маҕан шалкер дьааһыга",
  "block.minecraft.white_stained_glass": "Маҕан өстүөкүлэ",
  "block.minecraft.white_stained_glass_pane": "Маҕан чараас өстүөкүлэ",
  "block.minecraft.white_terracotta": "Маҕан кэрээмикэ",
  "block.minecraft.white_tulip": "Маҕан түлпээн",
  "block.minecraft.white_wool": "Маҕан түү",
  "block.minecraft.wildflowers": "Хонуу сибэккилэр",
  "block.minecraft.wither_rose": "Визер оруосата",
  "block.minecraft.wither_skeleton_skull": "Визер-дьардьама бас уҥуоҕа",
  "block.minecraft.wither_skeleton_wall_skull": "Визер-дьардьама истиэнэтээҕи бас уҥуоҕа",
  "block.minecraft.yellow_banner": "Араҕас былаах",
  "block.minecraft.yellow_bed": "Араҕас орон",
  "block.minecraft.yellow_candle": "Араҕас чүмэчи",
  "block.minecraft.yellow_candle_cake": "Араҕас чүмэчилээх торт",
  "block.minecraft.yellow_carpet": "Араҕас көбүөр",
  "block.minecraft.yellow_concrete": "Араҕас бетон",
  "block.minecraft.yellow_concrete_powder": "Араҕас бетон бороһуога",
  "block.minecraft.yellow_glazed_terracotta": "Өстүөкэлэлэммит араҕас кэрээмикэ",
  "block.minecraft.yellow_shulker_box": "Араҕас шалкер дьааһыга",
  "block.minecraft.yellow_stained_glass": "Араҕас өстүөкүлэ",
  "block.minecraft.yellow_stained_glass_pane": "Араҕас чараас өстүөкүлэ",
  "block.minecraft.yellow_terracotta": "Араҕас кэрээмикэ",
  "block.minecraft.yellow_wool": "Араҕас түү",
  "block.minecraft.zombie_head": "Дэриэтинник төбөтө",
  "block.minecraft.zombie_wall_head": "Дэриэтинник истиэнэтээҕи төбөтө",
  "item.minecraft.acacia_boat": "Акаассыйа оҥочо",
  "item.minecraft.acacia_chest_boat": "Дьаһыктаах акаассыйа оҥочо",
  "item.minecraft.allay_spawn_egg": "Сэмэйчик төрөтөр сымыыт",
  "item.minecraft.amethyst_shard": "Аметист үлтүркэйэ",
  "item.minecraft.angler_pottery_shard": "\"Илиилэри үөһээ\" керамическай үлтүркэй",
  "item.minecraft.angler_pottery_sherd": "\"Төбө уҥуоҕа\" керамическай үлтүркэй",
  "item.minecraft.apple": "Дьаабылака",
  "item.minecraft.archer_pottery_shard": "\"Бириис\" керамическай үлтүркэй",
  "item.minecraft.archer_pottery_sherd": "\"Охчут\" керамическай үлтүркэй",
  "item.minecraft.armadillo_scute": "Куйахсыт куйаҕа",
  "item.minecraft.armadillo_spawn_egg": "Куйахсыты төрөтөр сымыыт",
  "item.minecraft.armor_stand": "Куйах турар маһа",
  "item.minecraft.arms_up_pottery_shard": "\"Илиилэри үөһээ\" керамическай үлтүркэй",
  "item.minecraft.arms_up_pottery_sherd": "\"Илиилэри үөһээ\" керамическай үлтүркэй",
  "item.minecraft.arrow": "Ох",
  "item.minecraft.axolotl_bucket": "Аксолотллаах биэдэрэ",
  "item.minecraft.axolotl_spawn_egg": "Аксолотулу төрөтөр сымыыт",
  "item.minecraft.baked_potato": "Буспут хортуоппуй",
  "item.minecraft.bamboo_chest_raft": "Дьааһыктаах бамбук болуот",
  "item.minecraft.bamboo_raft": "Бамбук болуот",
  "item.minecraft.bat_spawn_egg": "Көтөр кутуйаҕы төрөтөр сымыыт",
  "item.minecraft.bee_spawn_egg": "Тигээйини төрөтөр сымыыт",
  "item.minecraft.beef": "Сиикэй ынах этэ",
  "item.minecraft.beetroot": "Сүбүөкүлэ",
  "item.minecraft.beetroot_seeds": "Сүбүөкүлэ сиэмэтэ",
  "item.minecraft.beetroot_soup": "Сүбүөкүлэ миинэ",
  "item.minecraft.birch_boat": "Хатыҥ оҥочо",
  "item.minecraft.birch_chest_boat": "Дьаһыктаах хатыҥ оҥочо",
  "item.minecraft.black_bundle": "Хара куул",
  "item.minecraft.black_dye": "Хара кырааска",
  "item.minecraft.black_harness": "Хара көлүүр",
  "item.minecraft.blade_pottery_shard": "\"Бириис\" керамическай үлтүркэй",
  "item.minecraft.blade_pottery_sherd": "\"Бириис\" керамическай үлтүркэй",
  "item.minecraft.blaze_powder": "Төлөннөөх бороһуок",
  "item.minecraft.blaze_rod": "Төлөн үөһэ",
  "item.minecraft.blaze_spawn_egg": "Төлөннөөҕү төрөтөр сымыыт",
  "item.minecraft.blue_bundle": "Халлаан күөх куул",
  "item.minecraft.blue_dye": "Күөх кырааска",
  "item.minecraft.blue_egg": "Халлаан күөх сымыыт",
  "item.minecraft.blue_harness": "Халлаан күөх көлүүр",
  "item.minecraft.bogged_spawn_egg": "Маарһыт төрөтөр сымыыт",
  "item.minecraft.bolt_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "«Киин» киэргэл",
  "item.minecraft.bone": "Уҥуох",
  "item.minecraft.bone_meal": "Уҥуох бурдук",
  "item.minecraft.book": "Кинигэ",
  "item.minecraft.bordure_indented_banner_pattern": "«Зубчатая кайма» былаах уһуора",
  "item.minecraft.bow": "Ох саа",
  "item.minecraft.bowl": "Кытыйа",
  "item.minecraft.bread": "Килиэп",
  "item.minecraft.breeze_rod": "Холорук үөһэ",
  "item.minecraft.breeze_spawn_egg": "Холоругу төрөтөр сымыыт",
  "item.minecraft.brewer_pottery_shard": "\"Охчут\" керамическай үлтүркэй",
  "item.minecraft.brewer_pottery_sherd": "\"Төбө уҥуоҕа\" керамическай үлтүркэй",
  "item.minecraft.brewing_stand": "Аптаах ууну буһарар тэрил",
  "item.minecraft.brick": "Кирпииччэ",
  "item.minecraft.brown_bundle": "Күрэҥ куул",
  "item.minecraft.brown_dye": "Күрэҥ кырааска",
  "item.minecraft.brown_egg": "Күрэҥ сымыыт",
  "item.minecraft.brown_harness": "Күрэҥ көлүүр",
  "item.minecraft.brush": "Киистэ",
  "item.minecraft.bucket": "Биэдэрэ",
  "item.minecraft.bundle": "Куул",
  "item.minecraft.bundle.empty": "Кураанах",
  "item.minecraft.bundle.empty.description": "Араас араас малы сатаан илдьэр",
  "item.minecraft.bundle.full": "Туолбут",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "\"Охчут\" керамическай үлтүркэй",
  "item.minecraft.burn_pottery_sherd": "\"Охчут\" керамическай үлтүркэй",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Тэбиэн төрөтөр сымыыт",
  "item.minecraft.carrot": "Моркуоп",
  "item.minecraft.carrot_on_a_stick": "Маска иилиллибит моркуоп",
  "item.minecraft.cat_spawn_egg": "Куосканы төрөтөр сымыыт",
  "item.minecraft.cauldron": "Солуур",
  "item.minecraft.cave_spider_spawn_egg": "Хаспах ооҕуйун төрөтөр сымыыт",
  "item.minecraft.chainmail_boots": "Сыап атах таҥаһа",
  "item.minecraft.chainmail_chestplate": "Сыап түөс таҥаһа",
  "item.minecraft.chainmail_helmet": "Cыап бэргэһэ",
  "item.minecraft.chainmail_leggings": "Сыап ыстаан",
  "item.minecraft.charcoal": "Мас чох",
  "item.minecraft.cherry_boat": "Вишня маһыттан тыы",
  "item.minecraft.cherry_chest_boat": "Вишня маһыттан таһар тыы",
  "item.minecraft.chest_minecart": "Дьааһыктаах богуончук",
  "item.minecraft.chicken": "Буспатах куурусса этэ",
  "item.minecraft.chicken_spawn_egg": "Кууруссаны төрөтөр сымыыт",
  "item.minecraft.chorus_fruit": "Хуорус отоно",
  "item.minecraft.clay_ball": "Туой хойуута",
  "item.minecraft.clock": "Чаһыы",
  "item.minecraft.coal": "Чох",
  "item.minecraft.coast_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.coast_armor_trim_smithing_template.new": "\"Кытыл\" киэргэл",
  "item.minecraft.cocoa_beans": "Какао-бобтар",
  "item.minecraft.cod": "Сиикэй треска",
  "item.minecraft.cod_bucket": "Трескалаах биэдэрэ",
  "item.minecraft.cod_spawn_egg": "Тресканы төрөтөр сымыыт",
  "item.minecraft.command_block_minecart": "Хамаандалар булуоктартаах богуончук",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Буспут ынах этэ",
  "item.minecraft.cooked_chicken": "Ыһаарыллыбыт куурусса этэ",
  "item.minecraft.cooked_cod": "Ыһаарыллыбыт треска",
  "item.minecraft.cooked_mutton": "Буһарыллыбыт хой этэ",
  "item.minecraft.cooked_porkchop": "Ыһаарыллыбыт сибиинньэ этэ",
  "item.minecraft.cooked_rabbit": "Буһарыллыбыт куобах этэ",
  "item.minecraft.cooked_salmon": "Ыһаарыллыбыт лосось",
  "item.minecraft.cookie": "Бэчиэнньэ",
  "item.minecraft.copper_axe": "Алтан сүгэ",
  "item.minecraft.copper_boots": "Алтан атах таҥаһа",
  "item.minecraft.copper_chestplate": "Алтан түөс таҥаһа",
  "item.minecraft.copper_golem_spawn_egg": "Алтан големы төрөтөр сымыыт",
  "item.minecraft.copper_helmet": "Алтан бэргэһэ",
  "item.minecraft.copper_hoe": "Алтан быһымньы",
  "item.minecraft.copper_horse_armor": "Алтан ат куйаҕа",
  "item.minecraft.copper_ingot": "Алтан кутуу",
  "item.minecraft.copper_leggings": "Алтан ыстаан",
  "item.minecraft.copper_nautilus_armor": "Наутилус алтан куйаҕа",
  "item.minecraft.copper_nugget": "Алтан кырбаһа",
  "item.minecraft.copper_pickaxe": "Алтан кирка",
  "item.minecraft.copper_shovel": "Алтан күрдьэх",
  "item.minecraft.copper_spear": "Алтан үҥүү",
  "item.minecraft.copper_sword": "Алтан кылыс",
  "item.minecraft.cow_spawn_egg": "Ыҥаҕы төрөтөр сымыыт",
  "item.minecraft.creaking_spawn_egg": "Кыычырҕааччыны төрөтөр сымыыт",
  "item.minecraft.creeper_banner_pattern": "Былаах оһуора",
  "item.minecraft.creeper_banner_pattern.desc": "Крипер",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Криперы төрөтөр сымыыт",
  "item.minecraft.crossbow": "Арбалет",
  "item.minecraft.crossbow.projectile": "Буулдьа:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Бирюза куул",
  "item.minecraft.cyan_dye": "Бирюза кырааска",
  "item.minecraft.cyan_harness": "Бирюза көлүүр",
  "item.minecraft.danger_pottery_shard": "\"Бириис\" керамическай үлтүркэй",
  "item.minecraft.danger_pottery_sherd": "\"Бириис\" керамическай үлтүркэй",
  "item.minecraft.dark_oak_boat": "Хара дууп оҥочо",
  "item.minecraft.dark_oak_chest_boat": "Дьааһыктаах хара дууп оҥочо",
  "item.minecraft.debug_stick": "Көннөрөр мас",
  "item.minecraft.debug_stick.empty": "%s уратылара туруоруллубатылар",
  "item.minecraft.debug_stick.select": "«%s» (%s) талылынна",
  "item.minecraft.debug_stick.update": "«%s»: %s",
  "item.minecraft.diamond": "Алмаас",
  "item.minecraft.diamond_axe": "Алмаас сүгэ",
  "item.minecraft.diamond_boots": "Алмаас атах таҥаһа",
  "item.minecraft.diamond_chestplate": "Алмаас түөс таҥаһа",
  "item.minecraft.diamond_helmet": "Алмаас бэргэһэ",
  "item.minecraft.diamond_hoe": "Алмаас быһымньы",
  "item.minecraft.diamond_horse_armor": "Алмаас ат куйаҕа",
  "item.minecraft.diamond_leggings": "Алмаас ыстаан",
  "item.minecraft.diamond_nautilus_armor": "Наутилус алмаас куйаҕа",
  "item.minecraft.diamond_pickaxe": "Алмаас кирка",
  "item.minecraft.diamond_shovel": "Алмаас күрдьэх",
  "item.minecraft.diamond_spear": "Алмаас үҥүү",
  "item.minecraft.diamond_sword": "Алмаас кылыс",
  "item.minecraft.disc_fragment_5": "Пластинка бытархайа",
  "item.minecraft.disc_fragment_5.desc": "Пластинка — 5",
  "item.minecraft.dolphin_spawn_egg": "Дельфины төрөтөр сымыыт",
  "item.minecraft.donkey_spawn_egg": "Өсүөлү төрөтөр сымыыт",
  "item.minecraft.dragon_breath": "Уот моҕой тыына",
  "item.minecraft.dried_kelp": "Хатарыллыбыт салахай",
  "item.minecraft.drowned_spawn_egg": "Тимирбити төрөтөр сымыыт",
  "item.minecraft.dune_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.dune_armor_trim_smithing_template.new": "\"Дюна\" киэргэл",
  "item.minecraft.echo_shard": "Дуораан үлтүркэйэ",
  "item.minecraft.egg": "Сымыыт",
  "item.minecraft.elder_guardian_spawn_egg": "Былыргы харабылдьыты төрөтөр сымыыт",
  "item.minecraft.elytra": "Элитралар",
  "item.minecraft.emerald": "Изумруд",
  "item.minecraft.enchanted_book": "Аптаах кинигэ",
  "item.minecraft.enchanted_golden_apple": "Аптаах көмүс дьаабылыка",
  "item.minecraft.end_crystal": "Энд кристала",
  "item.minecraft.ender_dragon_spawn_egg": "Эндер уот моҕойун төрөтөр сымыыт",
  "item.minecraft.ender_eye": "Эндэр хараҕа",
  "item.minecraft.ender_pearl": "Эндэр-чөмчүүк",
  "item.minecraft.enderman_spawn_egg": "Эндермены төрөтөр сымыыт",
  "item.minecraft.endermite_spawn_egg": "Эндермиты төрөтөр сымыыт",
  "item.minecraft.evoker_spawn_egg": "Апчыты төрөтөр сымыыт",
  "item.minecraft.experience_bottle": "Билиилээх бытыылка",
  "item.minecraft.explorer_pottery_shard": "\"Бириис\" керамическай үлтүркэй",
  "item.minecraft.explorer_pottery_sherd": "\"Бириис\" керамическай үлтүркэй",
  "item.minecraft.eye_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.eye_armor_trim_smithing_template.new": "\"Харах\" киэргэл",
  "item.minecraft.feather": "Куорсун",
  "item.minecraft.fermented_spider_eye": "Туустаммыт ооҕуй хараҕа",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Хаарты",
  "item.minecraft.fire_charge": "Уот иитиитэ",
  "item.minecraft.firework_rocket": "Фейерверк",
  "item.minecraft.firework_rocket.flight": "Көтүү уһуна:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Фейерверк сулуһа",
  "item.minecraft.firework_star.black": "Хара",
  "item.minecraft.firework_star.blue": "Күөх",
  "item.minecraft.firework_star.brown": "Күрэҥ",
  "item.minecraft.firework_star.custom_color": "Уларытылыбыт",
  "item.minecraft.firework_star.cyan": "Бирюза",
  "item.minecraft.firework_star.fade_to": "Умуллуу",
  "item.minecraft.firework_star.flicker": "Кылаҥнааһын",
  "item.minecraft.firework_star.gray": "Сур",
  "item.minecraft.firework_star.green": "От күөх",
  "item.minecraft.firework_star.light_blue": "Халлаан күөх",
  "item.minecraft.firework_star.light_gray": "Улаан",
  "item.minecraft.firework_star.lime": "Дьэҥкир күөх",
  "item.minecraft.firework_star.magenta": "Хараҥа кыһыл",
  "item.minecraft.firework_star.orange": "Чачархай",
  "item.minecraft.firework_star.pink": "Оруосабай",
  "item.minecraft.firework_star.purple": "Хара саарыл",
  "item.minecraft.firework_star.red": "Кыһыл",
  "item.minecraft.firework_star.shape": "Биллибэт быһыы",
  "item.minecraft.firework_star.shape.burst": "Чалым",
  "item.minecraft.firework_star.shape.creeper": "Крипер курдук",
  "item.minecraft.firework_star.shape.large_ball": "Улахан мээчик",
  "item.minecraft.firework_star.shape.small_ball": "Кыра мээчик",
  "item.minecraft.firework_star.shape.star": "Сулус курдук",
  "item.minecraft.firework_star.trail": "Суол",
  "item.minecraft.firework_star.white": "Маҥан",
  "item.minecraft.firework_star.yellow": "Араҕас",
  "item.minecraft.fishing_rod": "Күөгү",
  "item.minecraft.flint": "Чокуур таас",
  "item.minecraft.flint_and_steel": "Хатат",
  "item.minecraft.flow_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.flow_armor_trim_smithing_template.new": "«Барылҕан» киэргэл",
  "item.minecraft.flow_banner_pattern": "Былаах оһуора",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Былаах оһуора",
  "item.minecraft.flower_banner_pattern.desc": "Сибэкки",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Үүнэйи иһитэ",
  "item.minecraft.fox_spawn_egg": "Саһылы төрөтөр сымыыт",
  "item.minecraft.friend_pottery_shard": "\"Охчут\" керамическай үлтүркэй",
  "item.minecraft.friend_pottery_sherd": "\"Доҕор\" керамическай үлтүркэй",
  "item.minecraft.frog_spawn_egg": "Баҕаны төрөтөр сымыыт",
  "item.minecraft.furnace_minecart": "Оһохтоох богуончук",
  "item.minecraft.ghast_spawn_egg": "Гаст төрөтөр сымыыта",
  "item.minecraft.ghast_tear": "Гаст хараҕын уута",
  "item.minecraft.glass_bottle": "Бытыылка",
  "item.minecraft.glistering_melon_slice": "Сандаарар арбуус быһыыта",
  "item.minecraft.globe_banner_pattern": "Былаах оһуора",
  "item.minecraft.globe_banner_pattern.desc": "Глобус",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Тыгар отоннор",
  "item.minecraft.glow_ink_sac": "Тыгар чэрниилэ мөһөөччүгэ",
  "item.minecraft.glow_item_frame": "Тыгар араама",
  "item.minecraft.glow_squid_spawn_egg": "Тыгар кальмары төрөтөр сымыыт",
  "item.minecraft.glowstone_dust": "Сырдык таас быыла",
  "item.minecraft.goat_horn": "Чубуку муоһа",
  "item.minecraft.goat_spawn_egg": "Чубукуну төрөтөр сымыыт",
  "item.minecraft.gold_ingot": "Көмүс кутуу",
  "item.minecraft.gold_nugget": "Көмүс куһуок",
  "item.minecraft.golden_apple": "Көмүс дьаабылыка",
  "item.minecraft.golden_axe": "Көмүс сүгэ",
  "item.minecraft.golden_boots": "Кыһыл көмүс атах таҥаһа",
  "item.minecraft.golden_carrot": "Көмүс моркуоп",
  "item.minecraft.golden_chestplate": "Кыһыл көмүс түөс таҥаһа",
  "item.minecraft.golden_helmet": "Кыһыл көмүс бэргэһэ",
  "item.minecraft.golden_hoe": "Көмүс быһымньы",
  "item.minecraft.golden_horse_armor": "Көмүс ат куйаҕа",
  "item.minecraft.golden_leggings": "Кыһыл көмүс ыстаан",
  "item.minecraft.golden_nautilus_armor": "Наутилус көмүс куйаҕа",
  "item.minecraft.golden_pickaxe": "Көмүс кирка",
  "item.minecraft.golden_shovel": "Көмүс күрдьэх",
  "item.minecraft.golden_spear": "Көмүс үҥүү",
  "item.minecraft.golden_sword": "Кыһыл көмүс кылыс",
  "item.minecraft.gray_bundle": "Сүр куул",
  "item.minecraft.gray_dye": "Сур кырааска",
  "item.minecraft.gray_harness": "Сур көлүүр",
  "item.minecraft.green_bundle": "От күөх Куул",
  "item.minecraft.green_dye": "От күөх кырааска",
  "item.minecraft.green_harness": "От күөх көлүүр",
  "item.minecraft.guardian_spawn_egg": "Харабылдьыты төрөтөр сымыыт",
  "item.minecraft.gunpowder": "Буорах",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Холорук",
  "item.minecraft.guster_banner_pattern.new": "«Холорук» былаах оһуора",
  "item.minecraft.guster_pottery_sherd": "«Холорук» керамическай үлтүркэй",
  "item.minecraft.happy_ghast_spawn_egg": "Үөрбүт гаст төрөтөр сымыыт",
  "item.minecraft.harness": "Көлүүр",
  "item.minecraft.heart_of_the_sea": "Байҕал сүрэҕэ",
  "item.minecraft.heart_pottery_shard": "\"Сүрэх\" керамическай үлтүркэй",
  "item.minecraft.heart_pottery_sherd": "\"Сүрэх\" керамическай үлтүркэй",
  "item.minecraft.heartbreak_pottery_shard": "\"Кэлэйии\" керамическай үлтүркэй",
  "item.minecraft.heartbreak_pottery_sherd": "\"Кэлэйии\" керамическай үлтүркэй",
  "item.minecraft.hoglin_spawn_egg": "Хоглины төрөтөр сымыыт",
  "item.minecraft.honey_bottle": "Мүөт",
  "item.minecraft.honeycomb": "Тигээйии уйатын мүөтэ",
  "item.minecraft.hopper_minecart": "Боруоҥкалаах богуончук",
  "item.minecraft.horse_spawn_egg": "Аты төрөтөр сымыыт",
  "item.minecraft.host_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.host_armor_trim_smithing_template.new": "«Баһылык» киэргэл",
  "item.minecraft.howl_pottery_shard": "\"Тахсан таҕыс\" керамическай үлтүркэй",
  "item.minecraft.howl_pottery_sherd": "\"Тахсан таҕыс\" керамическай үлтүркэй",
  "item.minecraft.husk_spawn_egg": "Өлүгү төрөтөр сымыыт",
  "item.minecraft.ink_sac": "Чэрниилэ мөһөөччүгэ",
  "item.minecraft.iron_axe": "Тимир сүгэ",
  "item.minecraft.iron_boots": "Тимир атах таҥаһа",
  "item.minecraft.iron_chestplate": "Тимир түөс таҥаһа",
  "item.minecraft.iron_golem_spawn_egg": "Тимир големы төрөтөр сымыыт",
  "item.minecraft.iron_helmet": "Тимир бэргэһэ",
  "item.minecraft.iron_hoe": "Тимир быһымньы",
  "item.minecraft.iron_horse_armor": "Тимир ат куйаҕа",
  "item.minecraft.iron_ingot": "Тимир кутуу",
  "item.minecraft.iron_leggings": "Тимир ыстаан",
  "item.minecraft.iron_nautilus_armor": "Наутилус тимир куйаҕа",
  "item.minecraft.iron_nugget": "Тимир куһуок",
  "item.minecraft.iron_pickaxe": "Тимир кирка",
  "item.minecraft.iron_shovel": "Тимир күрдьэх",
  "item.minecraft.iron_spear": "Тимир үҥүү",
  "item.minecraft.iron_sword": "Тимир кылыс",
  "item.minecraft.item_frame": "Араама",
  "item.minecraft.jungle_boat": "Соҕурууҥу мас оҥочо",
  "item.minecraft.jungle_chest_boat": "Дьааһыктаах соҕурууҥу мас оҥочо",
  "item.minecraft.knowledge_book": "Билии кинигэтэ",
  "item.minecraft.lapis_lazuli": "Лазурит",
  "item.minecraft.lava_bucket": "Лаабалаах биэдэрэ",
  "item.minecraft.lead": "Тэһиин",
  "item.minecraft.leather": "Тирии",
  "item.minecraft.leather_boots": "Незерит атах таҥаһа",
  "item.minecraft.leather_chestplate": "Тирии дьоҕус",
  "item.minecraft.leather_helmet": "Тирии бэргэһэ",
  "item.minecraft.leather_horse_armor": "Тирии ат таҥаһа",
  "item.minecraft.leather_leggings": "Тирии ыстаан",
  "item.minecraft.light_blue_bundle": "Халлаан күөх куул",
  "item.minecraft.light_blue_dye": "Халлаан күөх кырааска",
  "item.minecraft.light_blue_harness": "Халлаан күөх көлүүр",
  "item.minecraft.light_gray_bundle": "Улаан куул",
  "item.minecraft.light_gray_dye": "Улаан кырааска",
  "item.minecraft.light_gray_harness": "Улаан көлүүр",
  "item.minecraft.lime_bundle": "Чээлэй Куул",
  "item.minecraft.lime_dye": "Дьэҥкир күөх кырааска",
  "item.minecraft.lime_harness": "Дьэҥкир күөх көлүүр",
  "item.minecraft.lingering_potion": "Туманнаах утах",
  "item.minecraft.lingering_potion.effect.awkward": "Тунаархай туманнаах утах",
  "item.minecraft.lingering_potion.effect.empty": "Сатаан оҥоһуллубат туманнаах утах",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Туманнаах утах: Уоту тулуйумтуо",
  "item.minecraft.lingering_potion.effect.harming": "Туманнаах утах: Буортулааһын",
  "item.minecraft.lingering_potion.effect.healing": "Туманнаах утах: Утүөрүү",
  "item.minecraft.lingering_potion.effect.infested": "Туманнаах утах: Сутуллуу",
  "item.minecraft.lingering_potion.effect.invisibility": "Туманнаах утах: Көстүбэт буолуу",
  "item.minecraft.lingering_potion.effect.leaping": "Туманнаах утах: Ыстаҥаһыт",
  "item.minecraft.lingering_potion.effect.levitation": "Туманнаах утах: Левитация",
  "item.minecraft.lingering_potion.effect.luck": "Туманнаах утах: Табыллыы",
  "item.minecraft.lingering_potion.effect.mundane": "Көннөрү туманнаах утах",
  "item.minecraft.lingering_potion.effect.night_vision": "Туманнаах утах: Түүҥҥү харах",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Туманнаах утах: Дьаат",
  "item.minecraft.lingering_potion.effect.regeneration": "Туманнаах утах: Чөлүгэр түһүү",
  "item.minecraft.lingering_potion.effect.slow_falling": "Туманнаах утах: Бытаан охтуу",
  "item.minecraft.lingering_potion.effect.slowness": "Туманнаах утах: Бытардыы",
  "item.minecraft.lingering_potion.effect.strength": "Туманнаах утах: Күүс",
  "item.minecraft.lingering_potion.effect.swiftness": "Туманнаах утах: Түргэтии",
  "item.minecraft.lingering_potion.effect.thick": "Хойуу туманнаах утах",
  "item.minecraft.lingering_potion.effect.turtle_master": "Туманнаах утах: Черепаха күүһэ",
  "item.minecraft.lingering_potion.effect.water": "Туманнаах утах бытыылката",
  "item.minecraft.lingering_potion.effect.water_breathing": "Туманнаах утах: Ууннан тыынааһын",
  "item.minecraft.lingering_potion.effect.weakness": "Туманнаах утах: Мөлтөтүү",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Лааманы төрөтөр сымыыт",
  "item.minecraft.lodestone_compass": "Магниттаах компас",
  "item.minecraft.mace": "Домох",
  "item.minecraft.magenta_bundle": "Хараҥа кыһыл куул",
  "item.minecraft.magenta_dye": "Хараҥа кыһыл кырааска",
  "item.minecraft.magenta_harness": "Хараҥа кыһыл көлүүр",
  "item.minecraft.magma_cream": "Магма чөмөҕө",
  "item.minecraft.magma_cube_spawn_egg": "Магма куубу төрөтөр сымыыт",
  "item.minecraft.mangrove_boat": "Мангра мас оҥочо",
  "item.minecraft.mangrove_chest_boat": "Дьааһыктаах мангра мас оҥочо",
  "item.minecraft.map": "Ыраас хаарты",
  "item.minecraft.melon_seeds": "Арбуус сиэмэтэ",
  "item.minecraft.melon_slice": "Арбуус быһыыта",
  "item.minecraft.milk_bucket": "Үүттээх биэдэрэ",
  "item.minecraft.minecart": "Богуончук",
  "item.minecraft.miner_pottery_shard": "\"Шахтер\" керамическай үлтүркэй",
  "item.minecraft.miner_pottery_sherd": "\"Шахтер\" керамическай үлтүркэй",
  "item.minecraft.mojang_banner_pattern": "Былаах оһуора",
  "item.minecraft.mojang_banner_pattern.desc": "Туох эрэ",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Муу-тэллэй төрөтөр сымыыт",
  "item.minecraft.mourner_pottery_shard": "\"Курутуйар\" керамическай үлтүркэй",
  "item.minecraft.mourner_pottery_sherd": "\"Курутуйар\" керамическай үлтүркэй",
  "item.minecraft.mule_spawn_egg": "Мул төрөтөр сымыыт",
  "item.minecraft.mushroom_stew": "Буһарыллыбыт тэллэй",
  "item.minecraft.music_disc_11": "Пластинка",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Пластинка",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Пластинка",
  "item.minecraft.music_disc_5.desc": "Самуель Оберг — 5",
  "item.minecraft.music_disc_blocks": "Пластинка",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Пластинка",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Пластинка",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Пластинка —",
  "item.minecraft.music_disc_creator.desc": "Лина Рейн — Creator",
  "item.minecraft.music_disc_creator_music_box": "Пластинка —",
  "item.minecraft.music_disc_creator_music_box.desc": "Лена Рейн — Creator (Музыкальнай шкатулка)",
  "item.minecraft.music_disc_far": "Пластинка",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Пластинка —",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Пластинка",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Пластинка",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Пластинка",
  "item.minecraft.music_disc_otherside.desc": "Лена Рейн — otherside",
  "item.minecraft.music_disc_pigstep": "Пластинка",
  "item.minecraft.music_disc_pigstep.desc": "Лена Рейн — Pigstep",
  "item.minecraft.music_disc_precipice": "Пластинка —",
  "item.minecraft.music_disc_precipice.desc": "Аарон Шероф — Precipice",
  "item.minecraft.music_disc_relic": "Пластинка —",
  "item.minecraft.music_disc_relic.desc": "Аарон Шероф — Relic",
  "item.minecraft.music_disc_stal": "Пластинка",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Пластинка",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Пластинка —",
  "item.minecraft.music_disc_tears.desc": "Эймос Родди — Tears",
  "item.minecraft.music_disc_wait": "Пластинка",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Пластинка",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Буспатах хой этэ",
  "item.minecraft.name_tag": "Аат суруга",
  "item.minecraft.nautilus_shell": "Наутилус куйаҕа",
  "item.minecraft.nautilus_spawn_egg": "Наутилуһу төрөтөр сымыыт",
  "item.minecraft.nether_brick": "Незер кирпииччэ",
  "item.minecraft.nether_star": "Незер сулуһа",
  "item.minecraft.nether_wart": "Незер үүнээйитэ",
  "item.minecraft.netherite_axe": "Незерит сүгэ",
  "item.minecraft.netherite_boots": "Незерит атах таҥаһа",
  "item.minecraft.netherite_chestplate": "Незерит түөс таҥаһа",
  "item.minecraft.netherite_helmet": "Незерит бэргэһэ",
  "item.minecraft.netherite_hoe": "Незерит быһымньы",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Незерит кутуу",
  "item.minecraft.netherite_leggings": "Незерит ыстаан",
  "item.minecraft.netherite_nautilus_armor": "Наутилус незерит куйаҕа",
  "item.minecraft.netherite_pickaxe": "Незерит кирка",
  "item.minecraft.netherite_scrap": "Незерит луома",
  "item.minecraft.netherite_shovel": "Незерит курдьэх",
  "item.minecraft.netherite_spear": "Незерит үҥүү",
  "item.minecraft.netherite_sword": "Незерит кылыс",
  "item.minecraft.netherite_upgrade_smithing_template": "Тимир уус халыыба",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Незеритынан саҥардыы",
  "item.minecraft.oak_boat": "Дууп оҥочо",
  "item.minecraft.oak_chest_boat": "Дьааһыктаах дууп оҥочо",
  "item.minecraft.ocelot_spawn_egg": "Баабыры төрөтөр сымыыт",
  "item.minecraft.ominous_bottle": "Өһүөннээх бытыылка",
  "item.minecraft.ominous_trial_key": "Өһүөннээх тургутуу күлүүһэ",
  "item.minecraft.orange_bundle": "Чачархай куул",
  "item.minecraft.orange_dye": "Чачархай кырааска",
  "item.minecraft.orange_harness": "Чачархай көлүүр",
  "item.minecraft.painting": "Уруһуй",
  "item.minecraft.pale_oak_boat": "Кубархай дууп тыы",
  "item.minecraft.pale_oak_chest_boat": "Дьааһыктаах кубархай дууп тыы",
  "item.minecraft.panda_spawn_egg": "Панданы төрөтөр сымыыт",
  "item.minecraft.paper": "Кумааҕы",
  "item.minecraft.parched_spawn_egg": "Кумахчыт төрөтөр сымыыта",
  "item.minecraft.parrot_spawn_egg": "Попугай төрөтөр сымыыта",
  "item.minecraft.phantom_membrane": "Үөр мембрааната",
  "item.minecraft.phantom_spawn_egg": "Үөр төрөтөр сымыыта",
  "item.minecraft.pig_spawn_egg": "Сибиинньэ төрөтөр сымыыта",
  "item.minecraft.piglin_banner_pattern": "Былаах оһуора",
  "item.minecraft.piglin_banner_pattern.desc": "Тумус",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Тойон пиглины төрөтөр сымыыт",
  "item.minecraft.piglin_spawn_egg": "Пиглины төрөтөр сымыыт",
  "item.minecraft.pillager_spawn_egg": "Халаанньыты төрөтөр сымыыт",
  "item.minecraft.pink_bundle": "Оруосабай куул",
  "item.minecraft.pink_dye": "Оруосабай кырааска",
  "item.minecraft.pink_harness": "Оруосабай көлүүр",
  "item.minecraft.pitcher_plant": "Купсуун үүнээйи",
  "item.minecraft.pitcher_pod": "Купсуун үүнүүтэ",
  "item.minecraft.plenty_pottery_shard": "\"Үгүс киһи\" керамическай үлтүркэй",
  "item.minecraft.plenty_pottery_sherd": "\"Үгүс киһи\" керамическай үлтүркэй",
  "item.minecraft.poisonous_potato": "Дьааттаах хортуоппуй",
  "item.minecraft.polar_bear_spawn_egg": "Үрүҥ эһэни төрөтөр сымыыт",
  "item.minecraft.popped_chorus_fruit": "Буспут хуорус отоно",
  "item.minecraft.porkchop": "Буспатах сибиинньэ этэ",
  "item.minecraft.potato": "Хортуоппуй",
  "item.minecraft.potion": "Аптаах уу",
  "item.minecraft.potion.effect.awkward": "Аптаах тунаархай уу",
  "item.minecraft.potion.effect.empty": "Сатаан оҥоһуллубат аптаах уу",
  "item.minecraft.potion.effect.fire_resistance": "Аптаах уу: Уоту тулуйумтуо",
  "item.minecraft.potion.effect.harming": "Аптаах уу: Буортулааһын",
  "item.minecraft.potion.effect.healing": "Аптаах уу: Үтүөрүү",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Аптаах уу: Көстүбэт буолуу",
  "item.minecraft.potion.effect.leaping": "Аптаах уу: Ыстаҥаһыт",
  "item.minecraft.potion.effect.levitation": "Аптаах уу: Тэлээрэн көтүү",
  "item.minecraft.potion.effect.luck": "Аптаах уу: Табыллыы",
  "item.minecraft.potion.effect.mundane": "Аптаах көннөрү уу",
  "item.minecraft.potion.effect.night_vision": "Аптаах уу: Түүҥҥү харах",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Аптаах уу: Дьаат",
  "item.minecraft.potion.effect.regeneration": "Аптаах уу: Чөлүгэр түһэрии",
  "item.minecraft.potion.effect.slow_falling": "Аптаах уу: Бытааннык түһүү",
  "item.minecraft.potion.effect.slowness": "Аптаах уу: Бытаардыы",
  "item.minecraft.potion.effect.strength": "Аптаах уу: Күүһүрдүү",
  "item.minecraft.potion.effect.swiftness": "Аптаах уу: Түргэтии",
  "item.minecraft.potion.effect.thick": "Аптаах хойуу уу",
  "item.minecraft.potion.effect.turtle_master": "Аптаах уу: Черепаха күүһэ",
  "item.minecraft.potion.effect.water": "Бытыылка уу",
  "item.minecraft.potion.effect.water_breathing": "Аптаах уу: Ууннан тыынааһын",
  "item.minecraft.potion.effect.weakness": "Аптаах уу: Мөлтөөһүн",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "\"Ох-саа\" керамическай үлтүркэй",
  "item.minecraft.pottery_shard_arms_up": "\"Илиилэри үөһээ\" керамическай үлтүркэй",
  "item.minecraft.pottery_shard_prize": "\"Бириис\" керамическай үлтүркэй",
  "item.minecraft.pottery_shard_skull": "\"Төбө уҥуоҕа\" керамическай үлтүркэй",
  "item.minecraft.powder_snow_bucket": "Көбдөркөй хаардаах биэдэрэ",
  "item.minecraft.prismarine_crystals": "Призмарин кристала",
  "item.minecraft.prismarine_shard": "Призмарин үлтүркэйэ",
  "item.minecraft.prize_pottery_shard": "\"Бириис\" керамическай үлтүркэй",
  "item.minecraft.prize_pottery_sherd": "\"Бириис\" керамическай үлтүркэй",
  "item.minecraft.pufferfish": "Иглобрюх",
  "item.minecraft.pufferfish_bucket": "Иглобрюхтаах биэдэрэ",
  "item.minecraft.pufferfish_spawn_egg": "Иглобрюх төрөтөр сымыыт",
  "item.minecraft.pumpkin_pie": "Тыыкыба бөрүөк",
  "item.minecraft.pumpkin_seeds": "Тыыкыба сиэмэтэ",
  "item.minecraft.purple_bundle": "Хара сарыыл куул",
  "item.minecraft.purple_dye": "Хара саарыл кырааска",
  "item.minecraft.purple_harness": "Хара саарыл көлүүр",
  "item.minecraft.quartz": "Незер-кварц",
  "item.minecraft.rabbit": "Буспатах куобах этэ",
  "item.minecraft.rabbit_foot": "Куобах атаҕа",
  "item.minecraft.rabbit_hide": "Куобах тириитэ",
  "item.minecraft.rabbit_spawn_egg": "Куобаҕы төрөтөр сымыыт",
  "item.minecraft.rabbit_stew": "Симэһинигэр буспут куобах",
  "item.minecraft.raiser_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "«Хомуйааччы» киэргэл",
  "item.minecraft.ravager_spawn_egg": "Урусхаллааччыны төрөтөр сымыыта",
  "item.minecraft.raw_copper": "Сиикэй алтан",
  "item.minecraft.raw_gold": "Сиикэй көмүс",
  "item.minecraft.raw_iron": "Сиикэй тимир",
  "item.minecraft.recovery_compass": "Төттөрүтэр компас",
  "item.minecraft.red_bundle": "Кыһыл куул",
  "item.minecraft.red_dye": "Кыһыл кырааска",
  "item.minecraft.red_harness": "Кыһыл көлүүр",
  "item.minecraft.redstone": "Редстоун быыла",
  "item.minecraft.resin_brick": "Сымала кирпииччэ",
  "item.minecraft.resin_clump": "Сымала хомоҕо",
  "item.minecraft.rib_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.rib_armor_trim_smithing_template.new": "\"Ойоҕос уҥуоҕа\" киэргэл",
  "item.minecraft.rotten_flesh": "Сытыйбыт эт",
  "item.minecraft.saddle": "Ыҥыыр",
  "item.minecraft.salmon": "Сиикэй лосось",
  "item.minecraft.salmon_bucket": "Лосостаах биэдэрэ",
  "item.minecraft.salmon_spawn_egg": "Лосось төрөтөр сымыыт",
  "item.minecraft.scrape_pottery_sherd": "\"Кыһыйыы\" керамическай үлтүркэй",
  "item.minecraft.scute": "Аччыгый куйах",
  "item.minecraft.sentry_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "\"Харабыллааччы\" киэргэл",
  "item.minecraft.shaper_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "«Оҥорооччу» киэргэл",
  "item.minecraft.sheaf_pottery_shard": "\"Мутук\" керамическай үлтүркэй",
  "item.minecraft.sheaf_pottery_sherd": "\"Мутук\" керамическай үлтүркэй",
  "item.minecraft.shears": "Кыптый",
  "item.minecraft.sheep_spawn_egg": "Хой төрөтөр сымыыт",
  "item.minecraft.shelter_pottery_shard": "\"Хахха\" керамическай үлтүркэй",
  "item.minecraft.shelter_pottery_sherd": "Shelter Pottery Sherd",
  "item.minecraft.shield": "Хахха",
  "item.minecraft.shield.black": "Хара хахха",
  "item.minecraft.shield.blue": "Күөх хахха",
  "item.minecraft.shield.brown": "Күрэҥ хахха",
  "item.minecraft.shield.cyan": "Бирюза хахха",
  "item.minecraft.shield.gray": "Сур хахха",
  "item.minecraft.shield.green": "От күөх хахха",
  "item.minecraft.shield.light_blue": "Халлаан күөх хахха",
  "item.minecraft.shield.light_gray": "Улаан хахха",
  "item.minecraft.shield.lime": "Дьэҥкир күөх хахха",
  "item.minecraft.shield.magenta": "Хараҥа кыһыл хахха",
  "item.minecraft.shield.orange": "Чачархай хахха",
  "item.minecraft.shield.pink": "Оруосабай хахха",
  "item.minecraft.shield.purple": "Хара саарыл хахха",
  "item.minecraft.shield.red": "Кыһыл хахха",
  "item.minecraft.shield.white": "Маҥан хахха",
  "item.minecraft.shield.yellow": "Араҕас хахха",
  "item.minecraft.shulker_shell": "Шалкер хаата",
  "item.minecraft.shulker_spawn_egg": "Шалкер төрөтөр сымыыта",
  "item.minecraft.sign": "Бэлиэ",
  "item.minecraft.silence_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.silence_armor_trim_smithing_template.new": "«Чуумпу» киэргэл",
  "item.minecraft.silverfish_spawn_egg": "Үөнү төрөтөр сымыыт",
  "item.minecraft.skeleton_horse_spawn_egg": "Дьардьама-аты төрөтөр сымыыт",
  "item.minecraft.skeleton_spawn_egg": "Дьардьаманы төрөтөр сымыыт",
  "item.minecraft.skull_banner_pattern": "Былаах оһуора",
  "item.minecraft.skull_banner_pattern.desc": "Бас уҥуох",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "\"Төбө уҥуоҕа\" керамическай үлтүркэй",
  "item.minecraft.skull_pottery_sherd": "Skull Pottery Sherd",
  "item.minecraft.slime_ball": "Салыҥ",
  "item.minecraft.slime_spawn_egg": "Слаймы төрөтөр сымыыт",
  "item.minecraft.smithing_template": "Тимир уус халыыба",
  "item.minecraft.smithing_template.applies_to": "Туһаныллар:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Слитка эбэтэр Кристаллы эбэн биэр",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Куйах",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Куйаххын уур",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Кутуулар уонна кристаллар",
  "item.minecraft.smithing_template.ingredients": "Матырыйааллар:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Незерит кутуу",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Алмаас куйах",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Алмаас куйаҕы, сэрии сэбин эбэтэр тэрили ук",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Незерит кутуу",
  "item.minecraft.smithing_template.upgrade": "Саҥардыы: ",
  "item.minecraft.sniffer_spawn_egg": "Сытырҕаһы төрөтөр сымыыт",
  "item.minecraft.snort_pottery_shard": "\"Урукку сыт\" керамическай үлтүркэй",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.snout_armor_trim_smithing_template.new": "\"Тумус\" киэргэл",
  "item.minecraft.snow_golem_spawn_egg": "Хаар големы төрөтөр сымыыт",
  "item.minecraft.snowball": "Хаар мээчик",
  "item.minecraft.spectral_arrow": "Дьэҥкир ох",
  "item.minecraft.spider_eye": "Ооҕуй хараҕа",
  "item.minecraft.spider_spawn_egg": "Ооҕуйу төрөтөр сымыыт",
  "item.minecraft.spire_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.spire_armor_trim_smithing_template.new": "\"Чыпчаал\" киэргэл",
  "item.minecraft.splash_potion": "Дэлби тэбэр уу",
  "item.minecraft.splash_potion.effect.awkward": "Дэлби тэбэр аптаах тунаархай уу",
  "item.minecraft.splash_potion.effect.empty": "Сатаан оҥоһуллубат дэлби тэбэр аптаах уу",
  "item.minecraft.splash_potion.effect.fire_resistance": "Дэлби тэбэр аптаах уу: Уоту тулуйумтуо",
  "item.minecraft.splash_potion.effect.harming": "Дэлби тэбэр аптаах уу: Буортулааһын",
  "item.minecraft.splash_potion.effect.healing": "Дэлби тэбэр аптаах уу: Үтүөрүү",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Дэлби тэбэр аптаах уу: Көстүбэт буолуу",
  "item.minecraft.splash_potion.effect.leaping": "Дэлби тэбэр аптаах уу: Ыстаҥаһыт",
  "item.minecraft.splash_potion.effect.levitation": "Дэлби тэбэр аптаах уу: Тэлээрэн көтүү",
  "item.minecraft.splash_potion.effect.luck": "Дэлби тэбэр аптаах уу: Табыллыы",
  "item.minecraft.splash_potion.effect.mundane": "Дэлби тэбэр аптаах көннөрү уу",
  "item.minecraft.splash_potion.effect.night_vision": "Дэлби тэбэр аптаах уу: Түүҥҥү харах",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Дэлби тэбэр аптаах уу: Дьаат",
  "item.minecraft.splash_potion.effect.regeneration": "Дэлби тэбэр аптаах уу: Чөлүгэр түһүү",
  "item.minecraft.splash_potion.effect.slow_falling": "Дэлби тэбэр аптаах уу: Бытааннык түһүү",
  "item.minecraft.splash_potion.effect.slowness": "Дэлби тэбэр аптаах уу: Бытардыы",
  "item.minecraft.splash_potion.effect.strength": "Дэлби тэбэр аптаах уу: Күүһүрдүү",
  "item.minecraft.splash_potion.effect.swiftness": "Дэлби тэбэр аптаах уу: Түргэтии",
  "item.minecraft.splash_potion.effect.thick": "Дэлби тэбэр аптаах хойуу уу",
  "item.minecraft.splash_potion.effect.turtle_master": "Дэлби тэбэр аптаах уу: Черепаха күүһэ",
  "item.minecraft.splash_potion.effect.water": "Дэлби тэбэр утах бытыылката",
  "item.minecraft.splash_potion.effect.water_breathing": "Дэлби тэбэр аптаах уу: Ууннан тыынааһын",
  "item.minecraft.splash_potion.effect.weakness": "Дэлби тэбэр аптаах уу: Мөлтөөһүн",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Харыйа оҥочо",
  "item.minecraft.spruce_chest_boat": "Дьааһыктаах харыйа оҥочо",
  "item.minecraft.spyglass": "Көрөр турба",
  "item.minecraft.squid_spawn_egg": "Кальмары төрөтөр сымыыт",
  "item.minecraft.stick": "Баалкы",
  "item.minecraft.stone_axe": "Таас сүгэ",
  "item.minecraft.stone_hoe": "Таас быһымньы",
  "item.minecraft.stone_pickaxe": "Таас кирка",
  "item.minecraft.stone_shovel": "Таас күрдьэх",
  "item.minecraft.stone_spear": "Таас үҥүү",
  "item.minecraft.stone_sword": "Таас кылыс",
  "item.minecraft.stray_spawn_egg": "Мууһурбут дьардьаманы төрөтөр сымыыт",
  "item.minecraft.strider_spawn_egg": "Страйдер төрөтөр сымыыта",
  "item.minecraft.string": "Сап",
  "item.minecraft.sugar": "Саахар",
  "item.minecraft.suspicious_stew": "Дьикти көрүҥнээх миин",
  "item.minecraft.sweet_berries": "Минньигэс отоннор",
  "item.minecraft.tadpole_bucket": "Баллыгынайдаах биэдэрэ",
  "item.minecraft.tadpole_spawn_egg": "Баллыгынай төрөтөр сымыыт",
  "item.minecraft.tide_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.tide_armor_trim_smithing_template.new": "\"Таһымныыр\" киэргэл",
  "item.minecraft.tipped_arrow": "Аптаммыт ох",
  "item.minecraft.tipped_arrow.effect.awkward": "Аптаммыт ох",
  "item.minecraft.tipped_arrow.effect.empty": "Сатаан оҥоһуллубат аптаах ууннан аптаммыт ох",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Уоту тулуйумтуо гынар ох",
  "item.minecraft.tipped_arrow.effect.harming": "Буортулатар ох",
  "item.minecraft.tipped_arrow.effect.healing": "Үтүөрдэр ох",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Көстүбэт гынар ох",
  "item.minecraft.tipped_arrow.effect.leaping": "Ыстаҥаһыт гынар ох",
  "item.minecraft.tipped_arrow.effect.levitation": "Левитациялатар ох",
  "item.minecraft.tipped_arrow.effect.luck": "Табыллыылах ох",
  "item.minecraft.tipped_arrow.effect.mundane": "Аптаммыт ох",
  "item.minecraft.tipped_arrow.effect.night_vision": "Түүҥҥэ көрөр ох",
  "item.minecraft.tipped_arrow.effect.oozing": "Слизистость ох",
  "item.minecraft.tipped_arrow.effect.poison": "Дьааттаах ох",
  "item.minecraft.tipped_arrow.effect.regeneration": "Чөлгө түһэрэр ох",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Бытааннык түһэрдэр ох",
  "item.minecraft.tipped_arrow.effect.slowness": "Бытаардар ох",
  "item.minecraft.tipped_arrow.effect.strength": "Күүһүрдүтэр ох",
  "item.minecraft.tipped_arrow.effect.swiftness": "Түргэтитэр ох",
  "item.minecraft.tipped_arrow.effect.thick": "Аптаммыт ох",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Черепаха күүһүн биэрэр ох",
  "item.minecraft.tipped_arrow.effect.water": "Эстэр ох",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Ууннан тыынааһыннатар ох",
  "item.minecraft.tipped_arrow.effect.weakness": "Мөлтөтөр ох",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Динамиттаах богуончук",
  "item.minecraft.torchflower_seeds": "Уотунньук сиэмэтэ",
  "item.minecraft.totem_of_undying": "Быстыбат олох тотема",
  "item.minecraft.trader_llama_spawn_egg": "Атыыһыт лааматын төрөтөр сымыыт",
  "item.minecraft.trial_key": "Тургутуу күлүүһэ",
  "item.minecraft.trident": "Үс тиис",
  "item.minecraft.tropical_fish": "Соҕурууҥу балык",
  "item.minecraft.tropical_fish_bucket": "Соҕурууҥҥу балыктаах биэдэрэ",
  "item.minecraft.tropical_fish_spawn_egg": "Соҕурууҥу балыгы төрөтөр сымыыт",
  "item.minecraft.turtle_helmet": "Черепаха хаата",
  "item.minecraft.turtle_scute": "Черепаха куйаҕа",
  "item.minecraft.turtle_spawn_egg": "Черепаханы төрөтөр сымыыт",
  "item.minecraft.vex_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.vex_armor_trim_smithing_template.new": "\"Үөннээх\" киэргэл",
  "item.minecraft.vex_spawn_egg": "Буортулааччыны төрөтөр сымыыт",
  "item.minecraft.villager_spawn_egg": "Дэриэбинэтээҕини төрөтөр сымыыт",
  "item.minecraft.vindicator_spawn_egg": "Көмүскээччини төрөтөр сымыыт",
  "item.minecraft.wandering_trader_spawn_egg": "Айанньыттаах атыыһыты төрөтөр сымыыт",
  "item.minecraft.ward_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.ward_armor_trim_smithing_template.new": "\"Харайааччы\" киэргэл",
  "item.minecraft.warden_spawn_egg": "Харайааччыны төрөтөр сымыыт",
  "item.minecraft.warped_fungus_on_a_stick": "Маска иилиллибит бутуллубут тэллэй",
  "item.minecraft.water_bucket": "Уулаах биэдэрэ",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "«Көрдөөччү» киэргэл",
  "item.minecraft.wheat": "Сэлиэһинэй",
  "item.minecraft.wheat_seeds": "Сэлиэһинэй сиэмэтэ",
  "item.minecraft.white_bundle": "Маҥан куул",
  "item.minecraft.white_dye": "Маҥан кырааска",
  "item.minecraft.white_harness": "Маҥан көлүүр",
  "item.minecraft.wild_armor_trim_smithing_template": "Тимир уус халыыба",
  "item.minecraft.wild_armor_trim_smithing_template.new": "\"Иһирик\" киэргэл",
  "item.minecraft.wind_charge": "Тыал иитиитэ",
  "item.minecraft.witch_spawn_egg": "Апчыт дьахтары төрөтөр сымыыт",
  "item.minecraft.wither_skeleton_spawn_egg": "Визер-дьардьаманы төрөтөр сымыыт",
  "item.minecraft.wither_spawn_egg": "Визеры төрөтөр сымыыт",
  "item.minecraft.wolf_armor": "Бөрө куйаҕа",
  "item.minecraft.wolf_spawn_egg": "Бөрөнү төрөтөр сымыыт",
  "item.minecraft.wooden_axe": "Мас Сүгэ",
  "item.minecraft.wooden_hoe": "Мас быһымньы",
  "item.minecraft.wooden_pickaxe": "Мас кирка",
  "item.minecraft.wooden_shovel": "Мас Күрдьэх",
  "item.minecraft.wooden_spear": "Мас үҥүү",
  "item.minecraft.wooden_sword": "Мас кылыс",
  "item.minecraft.writable_book": "Куорсуннаах кинигэ",
  "item.minecraft.written_book": "Суруллубут кинигэ",
  "item.minecraft.yellow_bundle": "Араҕас куул",
  "item.minecraft.yellow_dye": "Араҕас кырааска",
  "item.minecraft.yellow_harness": "Саһархай",
  "item.minecraft.zoglin_spawn_egg": "Зоглины төрөтөр сымыыт",
  "item.minecraft.zombie_horse_spawn_egg": "Зомби-аты төрөтөр сымыыт",
  "item.minecraft.zombie_nautilus_spawn_egg": "Зомби-наутилуһу төрөтөр сымыыт",
  "item.minecraft.zombie_spawn_egg": "Зомбины төрөтөр сымыыт",
  "item.minecraft.zombie_villager_spawn_egg": "Зомби-дэриэбинэтээҕини төрөтөр сымыыт",
  "item.minecraft.zombified_piglin_spawn_egg": "Зомби-пиглины төрөтөр сымыыт"
}
export const sah_sah = items; 
